{
  "buffs": {
    "settingsCard": {
      "hint": "추가한 버프를 관리하세요. 설정 버튼으로 알림을 조정할 수 있습니다.",
      "add": "버프 추가",
      "empty": "아직 추가한 버프가 없습니다. 버프를 추가하면 여기서 알림을 설정할 수 있습니다.",
      "edit": "{name} 설정",
      "threshold": "만료 {seconds}초 전 알림",
      "reminderOff": "만료 전 알림 꺼짐"
    },
    "manualTimer": {
      "label": "수동 타이머",
      "unit": "초",
      "helpLabel": "수동 타이머 안내",
      "help": "정확히 인식하면 게임 시간에 맞추고, 인식하지 못해도 카운트다운을 계속합니다.",
      "helpDetails": "0이 되면 설정한 시간으로 반복합니다. 시간 변경 시 다시 시작하고, 연결 해제 시 멈춥니다.",
      "helpExample": "사용 예: 기능을 켠 뒤 홀리 심볼의 남은 시간을 한 번 인식하게 해 주세요. 이후 버프를 받지 못한 차례에도 설정한 간격으로 계속 알려 줍니다.",
      "waiting": "카운트다운 인식 대기 중",
      "running": "수동 타이머 · {seconds}초마다 반복",
      "remaining": "수동 타이머 · {value}초 남음",
      "invalid": "1~86400 사이의 정수 초를 입력하세요"
    },
    "monitorNotReady": "모니터링 준비 안 됨",
    "unrecognized": "인식되지 않음",
    "activeUntimed": "활성",
    "paused": "모니터링 일시 중지",
    "frameInterrupted": "화면 중단",
    "remaining": "{value}초 남음",
    "itemSettings": {
      "heading": "알림 설정",
      "monitor": "이 버프를 모니터링하세요",
      "nearing": "만료 전",
      "seconds": "초",
      "visual": "아이콘 깜박임",
      "speech": "음성 알림",
      "shared": "모든 BUFF가 공유함",
      "priorityHint": "높은 숫자가 먼저 말함",
      "speaking": "말하기",
      "retryAudition": "음성으로 다시 시도해 보세요",
      "delete": "버프 삭제",
      "saving": "저장 중…",
      "saved": "저장됨"
    },
    "imageRecognition": "이미지 매칭",
    "defaultRegionHint": "기본적으로 여러 버프 행을 포함하고 하단 작업 표시줄을 제외하여 전체 너비 상위 30%를 검색합니다. 상자를 이동하거나, 오른쪽 하단 모서리의 크기를 조정하거나, 아래 비율을 편집하세요.",
    "dropShort": "아니면 이미지를 떨어뜨리세요",
    "localPrivate": "로컬에 저장됨",
    "catalogShort": "스킬 · 비BUFF 포함",
    "itemCatalogShort": "아이템 · 비BUFF 포함",
    "source": "온라인 검색 유형",
    "skills": "스킬",
    "items": "아이템",
    "searchItems": "아이템 검색",
    "automaticDetection": "자동 감지",
    "automaticDetectionHint": "BUFF를 추가하고 게임을 연결하여 아이콘을 찾고 자동으로 초를 읽습니다. 수동으로 선택할 필요가 없습니다.",
    "close": "닫기",
    "character": "캐릭터 상태",
    "clickSettings": "클릭하여 설정",
    "tooltipDrag": "드래그하여 순서 변경",
    "dragHint": "드래그하여 재정렬 · 이동하려면 Alt + 화살표 키",
    "save": "저장",
    "customRules": "맞춤 알림",
    "buffDefaults": "버프 알림",
    "advanced": "추가 설정",
    "emptyBar": "관심 있는 효과를 추가하세요. 모니터링은 게임 캡처부터 시작됩니다.",
    "filter": "직업별로 필터링",
    "adding": "추가",
    "addCount": "{count} 추가",
    "iconHint": "아이콘은 크기에 맞게 축소된 다음 필요할 때 래핑됩니다.",
    "recognitionTab": "통계인식",
    "buffCalibration": "버프 인식",
    "savedCount": "{count} 버퍼 추가",
    "reconnectHint": "캡처가 중단되었습니다. 위의 캡처 패널을 사용하여 게임을 다시 연결하세요.",
    "autoHint": "막대의 BUFF는 연결 시 모니터링됩니다. 중지하려면 하나를 삭제하세요",
    "previewHint": "통계는 샘플 데이터를 사용합니다. BUFF는 현재 상태를 보여줍니다. 크기를 조정하려면 오른쪽 하단 모서리를 드래그하세요.",
    "skinSettings": "설정에서 통계 스킨 변경",
    "autoSaved": "설정은 자동으로 로컬에 저장됩니다.",
    "advancedDiagnostic": "고급 진단",
    "regionFields": {
      "x": "왼쪽",
      "y": "탑",
      "width": "폭",
      "height": "신장"
    },
    "alertEvents": "경고할 시기",
    "alertChannels": "경고 채널",
    "previousPage": "이전 페이지",
    "nextPage": "다음 페이지",
    "previewState": "미리보기 상태",
    "previewStates": {
      "live": "실제 상태",
      "present": "활성",
      "seconds": "만료 예정 · 4초",
      "missing": "누락",
      "unknown": "확인되지 않음"
    },
    "title": "버프 관리자",
    "subtitle": "중요한 효과를 눈에 띄게 유지하고 모험에 집중하세요.",
    "add": "버프 알림 추가",
    "start": "모니터링 시작",
    "stop": "모니터링 중지",
    "openPip": "위젯 열기",
    "calibrationStates": {
      "waiting": "대기 중",
      "confirming": "찾기",
      "located": "위치",
      "missing": "아직 위치가 없습니다",
      "disabled": "추가된 대상이 없습니다.",
      "failed": "인식실패",
      "cancelled": "취소됨"
    },
    "locatedCount": "{count} / {total} 감지됨",
    "control": {
      "title": "버프 모니터",
      "subtitle": "바의 BUFF는 게임 화면 연결 후 자동으로 인식됩니다.",
      "settings": "모니터 설정",
      "empty": "구성되지 않음",
      "emptyTitle": "아직 모니터링할 BUFF가 없습니다.",
      "emptyHint": "스킬, 물약, 기타 효과 이미지를 추가하세요. 게임이 연결되면 모니터링이 시작됩니다.",
      "waitingCapture": "게임 화면을 기다리는 중",
      "waiting": "인식 대기 중",
      "preparing": "준비 중",
      "running": "모니터링",
      "interrupted": "게임 화면을 기다리는 중",
      "error": "인식 오류",
      "disabled": "추가된 대상이 없습니다.",
      "seconds": "{value}",
      "remindersHint": "기본 규칙은 모든 버프에 적용되며 항목별로 재정의될 수 있습니다."
    },
    "myBuffs": "내 버프",
    "enabledCount": "{count} 추가됨",
    "emptyTitle": "관심 있는 BUFF를 선택하세요",
    "emptyHint": "소책자 아이콘을 찾아보거나 자신만의 이미지를 추가하세요. 스킬, 물약 및 기타 효과가 지원됩니다.",
    "state": {
      "idle": "시작되지 않음",
      "preparing": "준비 중",
      "running": "모니터링",
      "waiting": "버프 바를 찾는 중",
      "interrupted": "게임 화면을 기다리는 중",
      "error": "시작할 수 없습니다"
    },
    "present": "활성",
    "missing": "누락",
    "unknown": "확인되지 않음",
    "idle": "시작되지 않음",
    "disabled": "장애인",
    "seconds": "{value} 초",
    "edit": "설정",
    "name": "이름",
    "enabled": "모니터링 활성화",
    "remove": "삭제",
    "undo": "삭제 취소",
    "removed": "{name}를 삭제했습니다.",
    "up": "위로 이동",
    "down": "아래로 이동",
    "reorder": "드래그하여 재정렬하세요.",
    "preview": "위젯 미리보기",
    "sample": "스타일 미리보기 · 샘플 상태",
    "livePreview": "실시간 상태",
    "appearance": "디스플레이 설정",
    "mode": "내용",
    "combined": "통계 + 버프",
    "stats": "통계만",
    "buffs": "버프만",
    "arrangement": "모듈 레이아웃",
    "auto": "자동",
    "vertical": "위아래로 배치",
    "horizontal": "좌우로 배치",
    "reverse": "모듈 위치 교체",
    "flow": "버프 레이아웃",
    "wrap": "랩",
    "row": "수평 스트립",
    "column": "수직 목록",
    "iconSize": "아이콘 크기",
    "gap": "아이콘 간격",
    "showNames": "이름 표시",
    "hiddenCount": "{count} 더; 창 스크롤 또는 확대",
    "enlarge": "더 보려면 창을 확대하세요.",
    "noTargets": "버프 추가",
    "manage": "버프 관리자 열기",
    "reminders": "기본 알림",
    "inherit": "기본 알림 규칙 사용",
    "threshold": "만료되기 몇 초 전",
    "visual": "시각적 경고",
    "speech": "음성 알림",
    "nearing": "곧 만료됨",
    "priority": "음성 우선순위",
    "summary": "만료 전 {seconds} · {voice}",
    "voiceOn": "음성 켜기",
    "voiceOff": "음성 꺼짐",
    "volume": "볼륨",
    "rate": "말하기 속도",
    "audition": "테스트 음성",
    "speechError": "음성을 재생할 수 없습니다. 브라우저 또는 시스템 오디오 설정을 확인하세요.",
    "online": "소책자 아이콘",
    "local": "로컬 이미지",
    "search": "스킬 이름 또는 ID 검색",
    "allJobs": "모든 직업",
    "catalogHint": "이 기술 디렉터리에는 버프가 아닌 기술도 포함되어 있습니다. 물약 및 기타 효과 이미지를 로컬로 추가합니다.",
    "loading": "로드 중",
    "retry": "재시도",
    "noResults": "일치하는 아이콘이 없습니다.",
    "added": "추가됨",
    "selected": "{count} 선택됨",
    "addSelected": "선택한 BUFF 추가",
    "cancel": "취소",
    "done": "완료",
    "drop": "여기에 이미지를 놓거나 이미지를 복사하여 붙여넣으세요.",
    "upload": "이미지 선택",
    "paste": "이미지 붙여넣기",
    "imageFormats": "PNG, JPEG, WebP · 각각 최대 10MB",
    "localOnly": "이미지는 이 브라우저에 유지됩니다. 게임 화면은 이 장치에서 처리됩니다.",
    "crop": "자르기",
    "cropHint": "드래그하여 아이콘을 선택하세요. 전체 이미지를 유지하려면 이 대화상자를 닫으세요.",
    "applyCrop": "자르기 적용",
    "duplicate": "이 이미지는 이미 추가되었습니다.",
    "importError": "이미지를 추가할 수 없습니다.",
    "clipboardEmpty": "클립보드에 읽을 수 있는 이미지가 없습니다. Ctrl+V로도 붙여넣을 수 있습니다.",
    "connectionError": "연결 실패",
    "catalogError": "아이콘 디렉터리를 일시적으로 사용할 수 없습니다.",
    "imageError": "아이콘 다운로드 실패",
    "saveError": "로컬에 저장할 수 없습니다. 브라우저 저장 공간을 확인하세요.",
    "detection": "게임 화면 및 인식 영역",
    "detectionHint": "전체 너비 및 여러 버프 행을 자동으로 검색합니다. 수동 선택은 선택 사항입니다. 스킬을 먼저 시전할 필요는 없습니다.",
    "selectRegion": "지역 선택",
    "autoRegion": "자동 지역",
    "regionHint": "게임 화면 위로 드래그하여 버프 검색 영역을 선택하세요.",
    "noCapture": "프레임을 미리 보려면 게임 창을 연결하세요.",
    "diagnostic": "로컬 진단 내보내기",
    "diagnosticHint": "시각적 후보, 표시된 값 및 타이밍이 포함됩니다. 게임 스크린샷이나 자동 업로드가 없습니다.",
    "clearDiagnostic": "명확한 진단",
    "fpsLimited": "캡처 프레임 속도를 조정할 수 없습니다. 인식이 더 느리게 반응할 수 있습니다.",
    "nearingNotice": "{name} 효과가 곧 끝납니다",
    "exp": "경험치/시간",
    "more": "추가 작업",
    "resetData": "BUFF 이미지, 설정 및 업로드한 오디오도 삭제됩니다."
  },
  "ocrQuality": {
    "manualEnhancement": "수동 영역 · 일반 보정",
    "preprocessRejected": "선택 영역이 인식 출처와 일치하지 않아 OCR로 전송되지 않았습니다. 전체 값을 선택하고 속성 창의 항목 이름이 보이도록 해 주세요.",
    "worldsLevelPreprocessRejected": "하단 바의 전체 레벨을 확인할 수 없어 OCR로 전송되지 않았습니다. 약간의 여백을 두고 레벨 숫자 전체를 선택해 주세요. LV.를 포함할 경우 라벨 전체가 보이도록 해 주세요.",
    "lowConfidence": "{confidence} 자신감에서 \"{text}\"를 마지막으로 읽었습니다. 최소한 {minimumConfidence}가 필요합니다.",
    "failed": "마지막 레벨 판독이 거부되었습니다: {reason}.",
    "retrying": "재시도 중입니다. 게임을 눈에 띄게 유지하세요.",
    "minimumConfidence": "레벨 신뢰 임계값",
    "attempt": "레벨 시도 {index}"
  },
  "firstUseCalibration": {
    "intro": "첫 번째 연결에서 게임 레이아웃 찾기. 상태 표시줄을 계속 표시하세요. 인벤토리를 열어 메소도 찾으세요.",
    "skip": "건너뛰기",
    "fallback": "위치가 없거나 이전에 보정된 영역이 없는 항목은 배경 감지가 계속되는 동안 기본 설정을 유지합니다. 해당 영역을 찾은 후에 판독값이 나타납니다.",
    "storageFailed": "최초 사용 인식 상태를 저장할 수 없습니다. 이번 방문은 반복되지 않지만 다음에 다시 실행될 수 있습니다."
  },
  "capability": {
    "insecureContext": {
      "title": "이 페이지는 안전하게 캡처하거나 인식할 수 없습니다.",
      "hint": "창 공유 및 로컬 인식에는 HTTPS가 필요합니다. 공식 주소를 통해 Maple Log를 오픈하세요.",
      "action": "공식 HTTPS 사이트 열기"
    },
    "embedded": {
      "title": "자체 탭에서 Maple Log 열기",
      "hint": "이 페이지는 포함된 프레임 안에 있으므로 창 공유 및 위젯이 안정적으로 작동하지 않습니다.",
      "action": "별도의 탭에서 열기"
    },
    "mobile": {
      "title": "컴퓨터에서 이 사이트를 엽니다.",
      "hint": "창 캡처에는 Windows 데스크톱 버전 Microsoft Edge, Google Chrome 또는 Firefox를 사용할 수 있습니다. 위젯을 항상 위에 표시하려면 Microsoft Edge 또는 Google Chrome이 필요합니다. 모바일에서도 기록과 순위를 볼 수 있습니다."
    },
    "unsupported": {
      "title": "이 브라우저는 게임 창을 캡처할 수 없습니다",
      "hint": "페이지 링크를 복사하고 최신 데스크톱 Microsoft Edge, Google Chrome 또는 Firefox에서 엽니다."
    },
    "storage": {
      "title": "이 브라우저는 로컬 기록을 저장할 수 없습니다",
      "hint": "비공개 모드 또는 차단된 사이트 데이터로 인해 기록 및 교정이 저장되지 않을 수 있습니다. 순위는 계속 볼 수 있습니다."
    },
    "simd": {
      "title": "이 브라우저는 로컬 인식을 실행할 수 없습니다",
      "hint": "WASM SIMD를 사용할 수 없습니다. 최신 데스크톱 Edge, Chrome 또는 Firefox를 사용하세요. 이 브라우저에서는 리소스가 다운로드되지 않습니다."
    },
    "popupHint": "이 브라우저는 게임 위에 위젯을 유지할 수 없습니다. 클릭하면 스트리밍 도구가 계속 캡처할 수 있는 일반 창이 열립니다.",
    "popupBlocked": "브라우저가 독립 실행형 창을 차단했습니다. 이 사이트에 대한 팝업을 허용하고 다시 시도하거나 공식 Edge/Chrome을 사용하세요.",
    "switchBrowser": "문제가 계속되면 최신 데스크톱 Microsoft Edge, Google Chrome 또는 Firefox를 사용해 보세요."
  },
  "pip": {
    "chooseMode": "위젯 열기 방식 선택",
    "modeUnavailable": "현재 브라우저 환경에서 사용할 수 없습니다",
    "modes": {
      "pip": { "name": "화면 속 화면", "hint": "항상 위에 표시되며 브라우저의 PIP를 사용합니다." },
      "popup": { "name": "별도 창", "hint": "PIP를 사용하지 않으며 항상 위에 표시되지 않습니다." }
    },
    "open": "위젯 열기",
    "opening": "여는 중…",
    "dismiss": "닫기",
    "retry": "다시 열어보세요",
    "retryPopup": "일반 창 열기",
    "copyLink": "페이지 링크 복사",
    "officialSite": "공식 사이트 오픈",
    "newTab": "새 탭에서 열기",
    "help": "도움말 보기",
    "diagnostics": "진단 보기",
    "copyDiagnostic": "진단 복사",
    "copied": "복사됨",
    "copyFailed": "자동으로 복사할 수 없습니다. 아래 텍스트를 선택하고 수동으로 복사하세요.",
    "manualCopy": "수동으로 복사할 텍스트",
    "selectWindow": "게임 창 선택",
    "retryOcr": "인식 다시 시도",
    "dashboard": "대시보드에서는 계속해서 통계를 볼 수 있습니다.",
    "captureFirst": "게임 창을 연결하고 인식 설정을 완료하면 대시보드에서 실시간 통계를 볼 수 있습니다.",
    "helpText": "이 페이지로 돌아와서 '다시 열어보세요'를 클릭하세요. 그래도 실패하면 데스크톱 Edge/Chrome을 업데이트하거나 브라우저 및 조직 제한 사항을 확인하세요.",
    "popupBadge": "일반 창구",
    "popupHint": "일반 창으로 열립니다. 게임 위에 항상 표시할 수는 없습니다.",
    "popupHelp": "창이 차단된 경우 해당 사이트에 대한 팝업을 허용하고 다시 시도하세요. 게임 위에 필요할 때 공식 데스크톱 Edge 또는 Chrome을 사용하세요.",
    "refreshHint": "다시 시도해도 도움이 되지 않으면 이 페이지를 새로 고치기 전에 현재 기록을 완료하세요.",
    "localDiagnostic": "브라우저 정보, 기능 확인 및 오류 범주만 포함됩니다. 이 페이지 세션 동안 보관되며 자동으로 업로드되지 않습니다.",
    "insecure-context": {
      "title": "이 페이지는 위젯을 열 수 없습니다",
      "hint": "페이지가 보안 컨텍스트에 있지 않습니다. HTTPS 주소를 통해 Maple Log에 액세스합니다."
    },
    "embedded": {
      "title": "자체 탭에서 Maple Log 열기",
      "hint": "이 페이지는 포함된 프레임 안에 있습니다. 위젯을 사용하려면 별도의 브라우저 탭에서 엽니다."
    },
    "unsupported": {
      "title": "이 브라우저에서는 위젯을 사용할 수 없습니다.",
      "hint": "링크를 복사하고 최신 데스크톱 Microsoft Edge 또는 Google Chrome에서 엽니다."
    },
    "not-connected": {
      "title": "먼저 게임창을 연결하세요",
      "hint": "실행 중인 게임 창을 선택하고 인식 설정을 마친 후 '위젯 열기'를 클릭하세요."
    },
    "ocr-preparing": {
      "title": "화면 인식 준비 중",
      "hint": "게임 연결 및 인식 설정이 완료될 때까지 기다린 후 '위젯 열기'를 클릭하세요."
    },
    "ocr-error": {
      "title": "화면 인식이 준비되지 않았습니다.",
      "hint": "설치를 완료할 수 없습니다. 위젯을 열기 전에 인식을 다시 시도하세요."
    },
    "ending": {
      "title": "기록 마무리",
      "hint": "기록이 저장된 후 위젯을 열 수 있습니다."
    },
    "reloading": {
      "title": "새로고침 준비 중",
      "hint": "페이지를 새로 고친 후 위젯을 열 수 있습니다."
    },
    "request-denied": {
      "title": "브라우저에서 이 시도를 허용하지 않았습니다.",
      "hint": "이 페이지로 돌아와서 '다시 열어보세요'를 클릭하세요. 독립 실행형 창이 열리면 이 사이트에 대한 팝업을 허용하세요.",
      "fallbackTitle": "Always-on-top을 사용할 수 없습니다.",
      "fallbackHint": "이 브라우저는 게임 위에 위젯을 유지할 수 없습니다. 아래를 클릭하시면 일반창이 열립니다. 스트리밍 도구는 여전히 이를 캡처할 수 있습니다."
    },
    "resource-load": {
      "title": "위젯 콘텐츠를 로드할 수 없습니다.",
      "hint": "인터넷 연결을 확인한 후 다시 시도하세요."
    },
    "unknown": {
      "title": "위젯을 열 수 없습니다",
      "hint": "다시 시도해 보세요. 그래도 실패하면 피드백에 포함할 진단을 복사하세요."
    }
  },
  "performance": {
    "buffCadence": "낮음·중간 설정에서는 남은 시간, 만료 또는 상태 변화를 확인할 때 BUFF 인식 간격이 잠시 0.5초로 빨라집니다. 카운트다운은 계속 갱신됩니다.",
    "buffFrequency": "BUFF 인식",
    "help": {
      "entry": "끊김 해결 방법",
      "title": "끊김 해결 방법",
      "graphics": "그래픽 가속 끄기",
      "systemLagTitle": "입력기나 시스템 메뉴도 멈추나요?",
      "systemLagIntro": "입력기, 시스템 메뉴, Alt+Tab도 멈춘다면 화면 오버레이나 바탕 화면 꾸미기 앱과 충돌했을 수 있습니다.",
      "conflictAction": "충돌하는 프로그램 종료",
      "conflictHint": "MSI Afterburner / RivaTuner, Nexus 등을 종료한 뒤 다시 시도하세요.",
      "widgetAction": "위젯을 끄거나 별도 창 사용",
      "widgetHint": "먼저 위젯을 닫으세요. 계속 쓰려면 버튼 오른쪽 화살표에서 ‘{mode}’을 선택하세요.",
      "firefoxAction": "Firefox로 전환",
      "firefoxHint": "계속 멈춘다면 Firefox를 사용해 보세요. 위젯을 맨 위에 고정할 수 없어 ‘{mode}’을 사용해야 합니다.",
      "browserTipsTitle": "페이지나 인식이 느린가요?",
      "system": "{browser} · 시스템 설정",
      "webpages": "{browser} · 웹페이지 설정",
      "firefox": "Firefox · 성능 → 권장 설정을 해제한 후 하드웨어 가속",
      "manual": "브라우저 설정에서 그래픽 또는 하드웨어 가속을 찾아 가능한 경우 끄십시오.",
      "copyLink": "주소 복사",
      "copied": "복사됨",
      "pasteHint": "주소창에 붙여넣고 가속을 끈 뒤 브라우저를 다시 시작하세요.",
      "copyFailed": "복사에 실패했습니다. 위의 주소를 수동으로 복사하세요.",
      "gameAcceleration": "컴퓨터 게임 가속 끄기",
      "gameAccelerationGuide": "{browser} · 성능 설정",
      "gameAccelerationPaste": "주소창에 붙여넣고 게임 가속을 끈 뒤 브라우저를 다시 시작하세요.",
      "lower": "인식 부하 낮추기",
      "currentTier": "현재: {tier} · 낮을수록 더 적은 리소스를 사용합니다.",
      "lowerAction": "레벨을 낮추세요",
      "lowest": "최저",
      "backgroundHint": "백그라운드 기록 중단 방지",
      "backgroundAction": "설정"
    },
    "navigation": {
      "tier": "간격",
      "advanced": "고급",
      "diagnostics": "진단"
    },
    "loadLevel": "인식부하",
    "frequencyOverview": "주파수 개요",
    "manualTuning": "미세 조정",
    "localOnly": "로컬 전용",
    "title": "인식 성능",
    "hint": "기기에 맞는 단계를 선택하여 화면 캡처, 화면 확인 및 각 항목의 인식 빈도를 함께 조정합니다.",
    "tiers": {
      "low": "낮음",
      "medium": "중간",
      "default": "기본값",
      "high": "높음",
      "ultra": "울트라"
    },
    "tierHints": {
      "low": "눈에 띄게 느린 업데이트로 부하를 최소화합니다.",
      "medium": "더 많은 리소스를 절약해야 하는 장치의 부하를 낮춥니다.",
      "default": "초당 한 번씩 캡처 및 검사하여 리소스 사용량과 업데이트 속도의 균형을 유지합니다.",
      "high": "더 빠른 업데이트가 필요한 안정적인 장치에 대해 더 자주 읽을 수 있는 기회입니다.",
      "ultra": "로드가 더 높은 가장 빈번한 읽기 기회입니다. 기기 성능에 따라 선택하세요."
    },
    "tierDetails": "사전 설정 세부정보 보기",
    "advanced": "고급 인식 설정",
    "everySeconds": "{count}초마다 1회",
    "demand": "인식요구",
    "resetAdvanced": "권장 값 복원",
    "lessLoad": "낮은 부하",
    "fasterUpdates": "더 빠른 업데이트",
    "recommended": "추천",
    "captureShort": "화면 캡처",
    "processingShort": "프레임 검사",
    "detailHint": "각 지표의 읽기 간격",
    "advancedHint": "엄격함과 화면 변화 민감도",
    "diagnosticHint": "로컬로 유지되는 런타임 측정",
    "targetHint": "이것이 목표 간격입니다. 새 프레임 전달, OCR 지속 시간 및 메트릭 일정으로 인해 실제 판독 속도가 느려질 수 있습니다. 수요 기반 검사의 최소 간격은 125ms입니다.",
    "pendingCapture": "인식 설정이 적용되었습니다. 캡처 속도는 다음 공유에 적용됩니다.",
    "deferred": "최신 선택 항목을 적용하기 전에 샘플링 시작/종료를 완료합니다. 캡처 변경 사항은 다음 공유에 적용됩니다.",
    "finalSampleIncomplete": "최종 샘플링이 불완전했습니다. 이전에 확인된 결과는 기록에 보관됩니다.",
    "captureLimit": "화면 캡처 프레임 속도 제한",
    "captureHint": "현재 공유를 중단하지 않고 다음에 소스를 선택할 때 적용됩니다. 실제 속도는 브라우저와 소스에 따라 다릅니다.",
    "processingLimit": "프레임 검사 비율 제한",
    "processingHint": "정기 프레임 검사에 즉시 적용됩니다. 기록을 시작하거나 종료할 때 필요한 샘플은 면제됩니다.",
    "defaultCapture": "기본값(10FPS 요청)",
    "defaultProcessing": "기본값(인식요구)",
    "fps": "{count} FPS",
    "tradeoff": "제한이 낮을수록 로드가 줄어들지만 업데이트가 느려지고 간단한 시각적 변화가 누락될 수 있습니다.",
    "reportTitle": "현지 진단 보고서",
    "reportHint": "이 페이지의 타이밍, 비율 및 오류 범주만 실행됩니다. 스크린샷, OCR 텍스트 또는 창 제목이 없습니다. 자동으로 업로드되지 않았습니다. 다시 로드하면 보고서가 지워집니다.",
    "refresh": "보고서 새로 고침",
    "copy": "보고서 복사",
    "download": "JSON 다운로드",
    "clear": "보고서 지우기",
    "details": "보고서 세부정보 보기",
    "reportedFps": "브라우저에서 보고된 캡처 속도",
    "frameTime": "평균 프레임 처리 시간",
    "ocrTime": "평균 OCR 시간",
    "resets": "OCR 엔진 재설정",
    "unavailable": "아직 데이터가 없습니다",
    "milliseconds": "{count} ms",
    "count": "{count}",
    "copied": "보고서가 복사되었습니다.",
    "copyFailed": "복사에 실패했습니다. 대신 보고서 세부정보의 텍스트를 복사하세요.",
    "downloaded": "보고서가 다운로드됨",
    "downloadFailed": "다운로드에 실패했습니다. 대신 보고서를 복사해 보세요.",
    "cleared": "보고서가 삭제되었습니다.",
    "refreshed": "보고서가 새로 고쳐졌습니다.",
    "limitation": "프레임 속도는 브라우저에서 보고됩니다. 이 페이지에서 타이밍이 측정됩니다. Windows 탐색기, 시스템 CPU 및 GPU 사용량을 사용할 수 없습니다. 단계당 최대 240개의 최근 샘플과 40개의 최근 오류가 유지됩니다."
  },
  "stream": {
    "connect": {
      "entry": "방송에 표시",
      "title": "방송에 표시하는 방법",
      "step1Title": "위젯 열기",
      "step1": "창 가장자리를 끌어 크기를 조정합니다.",
      "open": "위젯 열기",
      "opening": "여는 중",
      "openFailed": "위젯을 열 수 없습니다. 브라우저에서 PIP를 허용하고 다시 시도하세요.",
      "unsupported": "데스크톱 Chrome 또는 Edge를 사용하여 위젯을 엽니다.",
      "step2Title": "배경색을 선택하세요",
      "step2": "스트리밍 도구에서 제거할 수 있도록 텍스트 및 아이콘과 다른 단색을 선택하세요.",
      "copyColor": "색상 코드 복사",
      "copied": "복사됨",
      "copyFailed": "복사에 실패했습니다. 색상 값을 수동으로 복사합니다.",
      "solidNeeded": "이 배경에는 투명성이 있습니다. 키잉에는 불투명한 단색을 선택합니다.",
      "step3Title": "스트리밍 도구에 위젯 추가",
      "capture": "Window Capture를 추가하고 “Maple Log” 위젯 창을 선택하세요.",
      "keyColor": "제목 표시줄과 하단 컨트롤을 잘라내고 크로마키 또는 색상 키 필터를 추가하고 위의 배경색과 일치시킵니다.",
      "note": "스트리밍하는 동안 메인 페이지와 위젯을 열어두세요.",
      "done": "알았어요"
    },
    "camp": "설원 원정대",
    "clockwork": "루디브리엄 블록 스테이션",
    "pinkbean": "핑크빈 라디오",
    "kerning": "커닝시티 그래피티",
    "aqua": "아쿠아리움 항해",
    "ellinia": "엘리니아 · 숲의 속삭임",
    "orbis": "오르비스 · 구름 정원",
    "temple": "시간의 신전 · 시간의 회랑",
    "zakum": "자쿰 · 용암 제단",
    "skins": "스킨",
    "transparent": "투명(기본값)",
    "white": "화이트",
    "transparentShort": "투명",
    "charcoal": "진회색",
    "magentaShort": "마젠타",
    "greenShort": "녹색",
    "blueShort": "블루",
    "hexColor": "16진수 색상",
    "colorInvalid": "#FFFFFF 또는 #FFFFFF80과 같은 유효한 HEX 색상을 입력하세요.",
    "customColor": "맞춤 색상",
    "opacity": "불투명도",
    "daily": "기본 스킨",
    "title": "방송용 스킨",
    "classic": "모험 HUD",
    "mushroom": "주황버섯 친구",
    "minimal": "간결한 통계",
    "hint": "창이 축소되면 메소가 먼저, 그다음 BUFF가 숨겨집니다. 경험치 효율은 계속 표시됩니다.",
    "classicHint": "실버 배지 · 분할된 HUD",
    "mushroomHint": "주황색 버섯 · 크림 플라크",
    "minimalHint": "윤곽선 그림 · 열린 배경",
    "preview": "레이아웃 미리보기",
    "strip": "가로형",
    "classicLayout": "클래식",
    "portrait": "세로형",
    "backgroundHelpLabel": "배경 투명도 정보",
    "backgroundHelp": "투명성은 웹 콘텐츠에 적용됩니다. 브라우저는 여전히 PIP 창 배경을 칠하므로 그 뒤에 있는 앱은 숨겨진 상태로 유지됩니다. 스트리밍하려면 단색 배경을 선택하고 위젯 창을 캡처한 후 스트리밍 도구에서 크로마키 필터를 사용하여 해당 색상을 제거하세요.",
    "background": "위젯 배경",
    "magenta": "마젠타 크로마키",
    "green": "초록색 크로마키",
    "blue": "파란색 크로마키",
    "solid": "차콜 미리보기(키 없음)",
    "motion": "게임 애니메이션",
    "motionHint": "부드러운 유휴 및 레벨 업 동작. 움직임 감소를 존중합니다.",
    "obs": "OBS 설정",
    "obsSteps": "Window Capture를 추가하고 위젯을 선택하고 → 브라우저 제목 표시줄을 자르고 → 크로마키 필터를 추가하고 → 위젯 배경색을 일치시킵니다.",
    "obsNote": "바둑판은 투명성을 나타냅니다. 투명한 웹페이지는 투명한 PIP(Picture-in-Picture) 창을 보장하지 않습니다. OBS 캡처의 경우 단색 배경과 크로마키 필터를 사용하세요.",
    "obsColor": "마젠타 키: #FF00FF. 사용자 정의 색상을 사용하고 유사성과 부드러움을 조정합니다. 물약 아이콘과 텍스트 가장자리가 그대로 유지되는지 확인하세요.",
    "controls": "하단 컨트롤에서 기록을 시작, 일시 중지 또는 종료합니다. 스트리밍할 때 잘라내세요.",
    "sample": "샘플 데이터",
    "exp": "경험치 / 시간",
    "mesos": "메소 / 시간",
    "level": "레벨",
    "eta": "레벨업까지",
    "gained": "순 경험치",
    "net": "순 메소",
    "elapsed": "기록 시간",
    "start": "시작 메소",
    "balance": "보유 메소 변동",
    "full": "한 레벨 소요 시간",
    "map": "지도",
    "recording": "기록 중"
  },
  "captureRecovery": {
    "source-endedTitle": "공유가 종료되었습니다. 현재 게임 창을 다시 선택하세요",
    "source-endedHint": "게임 창을 닫거나 다시 열었다면 페이지를 새로고침하지 않고 공유 소스를 다시 선택하세요. 계정을 전환할 때는 이전 기록을 종료한 후 새 계정의 기록을 시작하세요.",
    "permission-deniedTitle": "창 공유 권한이 부여되지 않았습니다.",
    "security-restrictedTitle": "창 공유는 보안 또는 권한에 의해 제한됩니다.",
    "security-restrictedHint": "브라우저, 운영체제, 조직의 공유 권한을 확인한 후 게임 창을 다시 선택하세요.",
    "invalid-stateTitle": "이 페이지로 돌아와 다시 선택하세요.",
    "invalid-stateHint": "이 페이지로 다시 전환하고 \"게임 창 선택\"을 다시 클릭하여 공유를 시작하세요.",
    "insecure-contextTitle": "이 페이지는 안전하게 공유를 시작할 수 없습니다.",
    "insecure-contextHint": "창 공유에는 보안 연결이 필요합니다. HTTPS를 통해 공식 Maple Log 사이트를 열고 다시 시도하세요.",
    "embeddedTitle": "자체 탭에서 Maple Log 열기",
    "embeddedHint": "이 페이지는 포함된 프레임 안에 있습니다. 창을 공유하기 전에 별도의 브라우저 탭에서 엽니다.",
    "mobileTitle": "실시간 인식은 컴퓨터에서 이용하세요",
    "mobileHint": "Windows용 Edge / Chrome / Firefox를 지원합니다. 모바일에서도 기록과 순위를 볼 수 있습니다.",
    "mobileCopyLink": "링크 복사",
    "policy-blockedTitle": "이 페이지에서는 창 공유가 허용되지 않습니다.",
    "policy-blockedHint": "별도의 탭에서 Maple Log를 열고 다시 시도하세요. 그래도 실패하면 브라우저 또는 조직 공유 제한을 확인하세요.",
    "openOfficial": "공식 HTTPS 사이트 열기",
    "openStandalone": "별도의 탭에서 열기",
    "browserHelp": "브라우저 업데이트 및 전환 도움말",
    "updateSteps": "아래 주소를 복사하여 브라우저 주소 표시줄에 붙여넣은 후 열어서 {browser} 업데이트를 확인하세요. 업데이트 후 브라우저를 다시 시작하세요.",
    "updateMenu": "브라우저 메뉴의 도움말 또는 정보를 통해 업데이트를 확인하거나 최신 데스크톱 Edge/Chrome/Firefox를 사용하세요.",
    "copyUpdateAddress": "업데이트 주소 복사",
    "downloadEdge": "마이크로소프트 엣지 다운로드",
    "downloadChrome": "구글 크롬 다운로드",
    "downloadFirefox": "Firefox 다운로드",
    "copyPageLink": "이 페이지 링크 복사",
    "linkCopied": "주소가 복사되었습니다. 브라우저 주소 표시줄에 붙여넣어 엽니다.",
    "linkCopyFailed": "자동 복사에 실패했습니다. 아래 주소를 직접 선택하여 복사하세요.",
    "manualAddress": "수동복사 주소",
    "screenSteps": "아래 버튼을 클릭하세요. 브라우저 공유 대화 상자에서 \"전체 화면\"을 선택하고 게임이 포함된 화면을 선택한 다음 \"공유\"를 클릭하세요.",
    "tryScreen": "전체 화면을 캡처해 보세요",
    "retryScreen": "화면 캡처 다시 시도",
    "screenFailed": "전체 화면 캡처도 시작할 수 없습니다",
    "attemptFailed": "이 캡처 시도를 아직 시작할 수 없습니다.",
    "retryHint": "브라우저를 완전히 종료했다가 다시 열거나, 다시 캡처하기 전에 최신 Edge/Chrome/Firefox를 사용해 보세요.",
    "screenHint": "게임이 선택한 화면을 최대한 많이 채우고 화면을 최소화하거나 다른 창으로 덮지 않고 계속 표시되도록 합니다. 연결 후 레벨과 경험치를 확인하세요. 필요한 경우 인식 영역을 조정합니다.",
    "more": "추가 문제 해결 단계",
    "windowMode": "게임을 창 모드나 테두리 없는 모드로 전환하고 게임을 계속 표시하세요.",
    "factoryReset": "설정을 열고 공장 설정을 복원한 다음 게임 화면을 다시 연결해 보세요.",
    "updateBrowser": "이 브라우저를 최신 버전으로 업데이트하세요.",
    "browser": "브라우저를 완전히 종료했다가 다시 열거나 최신 Microsoft Edge/Google Chrome/Firefox를 사용해 보세요.",
    "driver": "여전히 캡처에 실패하면 컴퓨터를 다시 시작하고 그래픽 드라이버와 Windows를 업데이트하세요. 기록, 스트리밍 또는 원격 데스크톱 도구가 실행 중인 경우 해당 도구도 닫아보세요.",
    "compare": "메모장과 같은 일반 창을 사용해 보십시오. 게임만 실패하면 먼저 디스플레이 모드를 확인하십시오. 모든 소스가 실패하면 먼저 브라우저와 시스템을 확인하십시오.",
    "copy": "진단 복사",
    "copied": "진단이 복사되었습니다.",
    "copyFailed": "자동 복사에 실패했습니다. 아래 진단을 수동으로 선택하고 복사하십시오.",
    "diagnostic": "진단 캡처"
  },
  "appUpdate": {
    "eyebrow": "Maple Log · 업데이트",
    "title": "업데이트가 준비되었습니다",
    "hint": "새로고침하여 최신 버전을 즐기거나 계속 진행하여 준비가 되면 업데이트하세요.",
    "preview": "디자인 미리보기 · 페이지 새로 고침 없음",
    "previewFeedback": "미리보기만 가능합니다. 업데이트가 수행되지 않았습니다.",
    "previewClose": "미리보기 중에 카드가 계속 표시됩니다.",
    "recordingHint": "업데이트가 완료되고 이 기록이 저장되면 페이지가 새로 고쳐집니다.",
    "update": "업데이트하려면 새로고침하세요.",
    "endAndUpdate": "기록 완료 및 업데이트",
    "later": "나중에",
    "close": "30분 후에 알림",
    "available": "업데이트 가능",
    "saving": "저장 중",
    "activating": "업데이트 중",
    "blocked": "업데이트하기 전에 현재 작업이 완료될 때까지 기다리십시오.",
    "saveError": "저장이 완료되지 않았습니다. 페이지가 새로 고쳐지지 않았습니다. 데이터를 저장하고 업데이트해 보세요.",
    "activationError": "업데이트가 완료되지 않았습니다. 페이지가 새로 고쳐지지 않았습니다. 연결을 확인하고 다시 시도하세요.",
    "retry": "업데이트 재시도"
  },
  "leaderboard": {
    "server": "서버",
    "mxdcServer": "중국 클래식",
    "gcwServer": "GCW 국제 서버",
    "uploadSourceRule": "창 공유가 필요합니다. 공유할 때마다 제목을 한 번 확인합니다. {title}와 명백히 다른 제목이면 전체 기록이 제외됩니다. 제목 표시줄이 없는 전체 화면 캡처와 확인되지 않은 제목은 기본적으로 허용됩니다. 창을 변경하거나 전체 화면으로 전환해도 제외된 기록은 복원되지 않습니다. 로컬 통계 및 기록은 영향을 받지 않습니다.",
    "sourceNotice": {
      "capture-not-window": "이 기록물은 순위에서 제외됩니다. 창 공유가 필요합니다. 지역 추적은 계속됩니다. 다시 자격을 얻으려면 창을 공유하고 새 기록을 시작하세요.",
      "capture-title-mismatch": "이 기록는 순위에서 제외됩니다. 창 제목이 일치하지 않습니다. 지역 추적은 계속됩니다. 대상 게임을 공유하고 새로운 기록를 시작하여 다시 자격을 얻으세요."
    },
    "mapTip": {
      "details": "세부정보",
      "openPage": "새 탭에서 {name}에 대한 지도 정보 열기",
      "open": "{name} 지도 정보 보기",
      "kind": "지도",
      "loading": "지도 정보 로드 중",
      "empty": "사용 가능한 지도 정보가 없습니다.",
      "error": "지도 정보를 로드할 수 없습니다. 다시 시도해 주세요.",
      "monsterCount": "몬스터",
      "npcCount": "NPC",
      "monsters": "이 맵의 몬스터",
      "npcs": "이 맵의 NPC",
      "description": "지도 노트",
      "noNpcs": "NPC 없음",
      "noMonsters": "괴물 없음",
      "more": "외 {count}개…",
      "image": "{name}의 미니맵",
      "noImage": "미니맵을 사용할 수 없습니다."
    },
    "title": "레벨업 맵 순위",
    "levelRange": "레벨 {start}–{end}",
    "levelSample": "이 행은 {start}–{end} 레벨의 문자 레코드를 사용합니다.",
    "allLevels": "모두",
    "minutes": "{count} 분",
    "sampleAccumulation": "동일한 맵, 동일한 레벨 범위 및 동일한 소스의 플레이어 기록은 하나의 샘플로 누적될 수 있습니다. 전체 등급 순위는 각 등급 범위를 별도로 계산하여 표시합니다.",
    "level": "레벨",
    "position": "순위",
    "status": "상태",
    "collectingTab": "수집",
    "formalTab": "공식",
    "sourceFilter": "소스",
    "hourlyExp": "경험치/시간",
    "hourlyReference": "참조 경험치/시간",
    "records": "{count} 레코드",
    "sourceSamples": "데이터 소스",
    "allSourcesShort": "모두",
    "collapse": "세부정보 접기",
    "closeDetails": "{name} 세부정보 닫기",
    "exp": "경험치 효율성",
    "perHour": "경험치/시간",
    "typical": "순위 계산 방법",
    "samples": "데이터 기여",
    "filters": "필터",
    "filterTitle": "지도 필터링",
    "reset": "필터 재설정",
    "done": "결과 보기",
    "search": "지도 검색",
    "searchPlaceholder": "지도 이름이나 ID로 검색",
    "searchClear": "검색 지우기",
    "filtersOpen": "필터 열기",
    "filtersCount": "{count} 선택됨",
    "removeFilter": "{label} 제거",
    "rules": "순위 규칙",
    "details": "지도 세부정보",
    "openDetails": "{name} 세부정보 보기",
    "scope": "{level} · {job} · {source}",
    "count": "{count} 지도",
    "page": "페이지 {current} / {total}",
    "previous": "이전 페이지",
    "next": "다음 페이지",
    "goToPage": "{page} 페이지로 이동",
    "scale": "이 페이지 비교",
    "sorted": "중간 속도로 정렬",
    "collecting": "데이터 수집",
    "moreUsers": "플레이어 1명 더 | {count} 더 많은 플레이어",
    "moreMinutes": "1분 더 | {count} 추가 분",
    "met": "만난",
    "usersProgress": "플레이어",
    "timeProgress": "유효시간",
    "sampleRule": "공식 순위 요구 사항",
    "uploadRule": "Maple Log 업로드 요구 사항",
    "uploadEligibility": "각 세그먼트에는 동일한 맵과 동일한 5레벨 범위 내에서 유효한 경험치 데이터의 {minutes}분과 양수 경험치 이득이 필요합니다. 별도의 세그먼트는 결합되지 않습니다.",
    "uploadTiming": "세션을 종료하면 적합한 세그먼트가 자동으로 업로드됩니다. 일시 중지 또는 연결 끊김은 이미 자격을 갖춘 세그먼트를 삭제하지 않습니다.",
    "qualificationHelp": "더 많은 데이터가 필요한 지도는 수집 아래에 나타납니다.",
    "distribution": "플레이어 간 경험치 요금",
    "source": "데이터 소스",
    "updated": "마지막 업데이트",
    "median": "중간 속도",
    "low": "속도를 낮추세요",
    "high": "더 빠른 속도",
    "upper": "빠른 속도",
    "medianHelp": "지도는 플레이어 전체의 중간 경험치/시간 결과를 기준으로 순위가 매겨집니다. 유효한 레코드만 계산됩니다.",
    "rangeHelp": "약 절반의 플레이어가 낮은 속도와 높은 속도 사이에 속합니다. 빠른 속도는 상위 10%에 가까우며 사상 최고치는 아니다.",
    "empty": "여기에는 아직 지도가 없습니다.",
    "emptyHint": "지도를 검색해 보거나 다른 레벨 범위, 직업, 출처를 선택하세요.",
    "gcwEmptyHint": "지도를 검색하거나 다른 레벨 범위를 선택하세요.",
    "error": "순위를 로드할 수 없습니다.",
    "refreshFailed": "새로고침에 실패했습니다. 이전 결과가 계속 표시됩니다.",
    "reference": "참조 효율성",
    "pending": "순위 업데이트를 기다리는 중",
    "back": "목록으로 돌아가기",
    "closeDossier": "지도 서류 닫기",
    "dossier": "지도 서류",
    "identity": "지도",
    "efficiency": "훈련 속도",
    "trust": "표본 신뢰도",
    "monsters": "몬스터",
    "drops": "주목할만한 하락",
    "equipment": "장비",
    "scroll": "스크롤",
    "dropRateLabel": "드롭 확률 {rate}, {tier}",
    "dropRateTier": {"high": "상대적으로 높음", "medium": "상대적으로 보통", "low": "상대적으로 낮음", "neutral": ""},
    "dropRateValue": "드롭 확률 {rate}",
    "dropSources": "드롭 몬스터",
    "allDropMonsters": "모든 몬스터",
    "dropMonsterFilter": "드롭 몬스터 필터",
    "unknownDropRate": "알 수 없음",
    "noDropSources": "드롭 몬스터 정보 없음",
    "relativeDropRates": "색상은 현재 필터 내의 상대적인 드롭 확률을 나타냅니다.",
    "maxMonsterDropRate": "이 맵의 드롭 몬스터 중 알려진 최고 확률이며 캐릭터 보너스는 포함하지 않습니다.",
    "noMonsters": "이 맵에는 아직 몬스터 데이터가 없습니다.",
    "noDrops": "이 지도에는 아직 확인된 드롭이 없습니다.",
    "noMapDetail": "아직 이 지도에 대한 서류가 없습니다.",
    "notes": "지도 노트",
    "loadingDetail": "지도 세부정보 로드 중",
    "detailError": "지도 세부정보를 로드할 수 없습니다.",
    "openBooklet": "小冊子에서 열기",
    "openBookletNamed": "小冊子에서 {name} 열기",
    "spawn": "{count}",
    "monsterLevel": "Lv.{level}",
    "trustFormal": "{users} 플레이어 · {duration}",
    "trustUsersUnit": "선수",
    "hoursUnit": "시간",
    "collectingNeed": "외 {users}명 · {time}",
    "selectMap": "{name} 보기",
    "moreFilters": "더 많은 필터",
    "partnership": "小冊子 사용",
    "entityLoading": "세부정보 로드 중",
    "entityEmpty": "세부정보가 없습니다.",
    "entityError": "세부정보를 로드할 수 없습니다.",
    "entityKind": {
      "mob": "몬스터",
      "item": "품목"
    }
  },
  "app": {
    "name": "Maple Log",
    "tagline": "메이플스토리 경험치 측정",
    "localOnly": "게임 화면은 기기에서만 처리",
    "currentPreset": "현재 사전 설정",
    "primaryNav": "주 메뉴",
    "useDark": "다크 모드로 전환",
    "useLight": "라이트 모드로 전환",
    "language": "표시 언어",
    "install": "앱 설치"
  },
  "startup": {
    "startingEngine": "인식 엔진 시작",
    "windowSelectedStage": "게임 창이 선택됨",
    "preparingRecognition": "인식 준비 중",
    "confirmingGameType": "게임 종류 확인 중",
    "gameDetectionFailures": {
      "dimensions-changed": "게임 창 크기가 변경되었습니다. 창 크기를 유지한 후 다시 시도하세요.",
      "profile-changed": "인식 설정이 변경되었습니다. 인식을 다시 시작한 후 다시 시도하세요.",
      "probe-error": "게임 종류를 확인할 수 없습니다. 게임 화면 전체가 보이도록 한 후 다시 시도하세요."
    },
    "timeoutTitle": "인식 엔진 시작 시간이 초과되었습니다.",
    "timeoutHint": "인식 엔진 시작 시간이 초과되었습니다. 다시 시작해 보세요. 선택한 창이 유지됩니다.",
    "sdkTimeoutHint": "인식 프로그램을 로드하는 데 시간이 너무 오래 걸렸습니다. 다시 시작해 보세요. 그래도 실패하면 페이지를 다시 로드하고 창을 다시 선택하세요.",
    "retryEngine": "다시 시작",
    "copyDiagnostic": "진단 복사",
    "diagnosticCopied": "진단이 복사되었습니다.",
    "diagnosticCopyFailed": "자동 복사에 실패했습니다. 아래 진단을 수동으로 복사하세요.",
    "diagnosticLabel": "시동 진단",
    "stepWindow": "게임 화면 연결",
    "stepWindowConnected": "연결됨",
    "stepWindowConnecting": "연결 중...",
    "stepWindowSelected": "창 선택됨",
    "stepModel": "인식 모델 로드",
    "stepModelReady": "준비 완료",
    "stepModelLoading": "로드 중",
    "stepModelChecking": "캐시 확인",
    "stepEngine": "로컬 엔진 시작",
    "stepEngineStarting": "초기화 중...",
    "stepEngineReady": "준비 완료",
    "title": "화면 인식 준비 중",
    "subtitle": "인식 리소스를 확인하고 로드하는 중입니다. 준비되면 미리보기가 자동으로 시작됩니다.",
    "connectingSubtitle": "프레임 연결을 완료하는 중입니다. 다음에는 인식 리소스가 자동으로 준비됩니다.",
    "initializingTitle": "화면 인식 시작",
    "initializingSubtitle": "인식 리소스가 준비되었습니다. 로컬 엔진이 시작됩니다.",
    "windowSelected": "게임 창이 선택됨",
    "windowConnected": "게임창이 연결되었습니다",
    "localProcessing": "인식은 이 기기에 유지됩니다.",
    "engineLabel": "Maple Log 인식",
    "progress": "로딩 진행상황",
    "cacheChecking": "이 브라우저에 이미 저장된 인식 리소스 확인 중",
    "cached": "{count}/2 인식 리소스 준비됨",
    "localHint": "처음 사용할 때 리소스가 로드됩니다. 일단 저장하면 향후 시작이 더 빨라질 것입니다.",
    "initializingLocalHint": "창 권한은 유지됩니다. 창을 다시 선택하지 않고도 시동을 다시 시도할 수 있습니다.",
    "idle": "창문을 기다리는 중",
    "connectingFrame": "게임 화면 연결",
    "checking": "로컬 리소스 확인 중",
    "detection": "화면 위치 준비 중",
    "recognition": "텍스트 인식 준비 중",
    "prepared": "표창 자료 준비",
    "initializing": "인식 엔진 시작",
    "ready": "설정 완료",
    "phaseCheck": "리소스 확인",
    "phaseRecognition": "인식 준비",
    "phaseReady": "시작 완료",
    "errorTitle": "인식 엔진 설정에 실패했습니다.",
    "errorStatus": "설정이 완료되지 않았습니다.",
    "errorHint": "잠시 후 다시 시도하세요. 이미 준비된 리소스는 다시 가져오지 않습니다.",
    "resourceErrorTitle": "인식 리소스를 로드할 수 없습니다.",
    "resourceErrorHint": "인식 리소스를 다운로드하지 못했습니다. 연결을 확인하고 다시 시도하세요. IDM 다운로드 창이 나타났다면 브라우저의 IDM Integration Module 확장 프로그램을 일시적으로 비활성화한 후 다시 시도하세요. IDM 프로그램만 종료하면 문제가 해결되지 않을 수 있습니다.",
    "initializationErrorTitle": "인식 엔진을 시작할 수 없습니다.",
    "initializationErrorHint": "브라우저에서 화면 인식을 시작할 수 없습니다. 다른 까다로운 탭을 닫고 다시 시도하세요.",
    "simdErrorTitle": "이 브라우저는 로컬 인식을 실행할 수 없습니다",
    "simdErrorHint": "WASM SIMD를 사용할 수 없습니다. 최신 데스크톱 Edge, Chrome 또는 Firefox를 사용하세요. 이 브라우저에서는 리소스가 다운로드되지 않습니다.",
    "insecure-contextErrorTitle": "이 페이지에서는 인식을 안전하게 준비할 수 없습니다.",
    "insecure-contextErrorHint": "로컬 인식에는 HTTPS가 필요합니다. 공식 주소를 통해 Maple Log를 열고 게임 창을 연결하세요.",
    "unknownErrorTitle": "로드가 완료되지 않았습니다.",
    "unknownErrorHint": "예상치 못한 문제로 인해 시작이 중단되었습니다. 다시 시도해 주세요.",
    "browserRecommendationTitle": "다른 브라우저를 사용해 보세요",
    "browserRecommendationHint": "다시 시도한 후에도 설정이 계속 실패하면 최신 Microsoft Edge, Google Chrome 또는 Firefox에서 Maple Log를 다시 엽니다.",
    "fixesLabel": "기타 시도해볼 사항",
    "factoryResetFixTitle": "설정에서 공장 설정 복원",
    "factoryResetFixHint": "로컬 보정 및 기본 설정을 지운 다음 인식을 다시 준비하세요.",
    "factoryResetFixAction": "설정 열기",
    "updateBrowserFixTitle": "브라우저 업데이트",
    "updateBrowserFixHint": "브라우저 업데이트를 확인한 다음 Maple Log를 다시 엽니다.",
    "cacheDegradedWarning": "지금은 인식이 작동하지만 리소스를 저장할 수 없으며 다음에 다시 로드해야 할 수도 있습니다.",
    "retry": "다시 시도하세요",
    "continue": "지금은 닫음"
  },
  "nav": {
    "security": "안전성 보고서",
    "securityBadge": "공개",
    "securityShort": "안전",
    "dashboard": "대시보드",
    "live": "실시간 기록",
    "calibration": "인식 위치 보정",
    "history": "기록 내역",
    "rank": "사냥터 순위",
    "rankShort": "사냥터 순위",
    "rankPartner": "小冊子와 협력하여",
    "settings": "설정",
    "changelog": "업데이트 내역",
    "about": "소개"
  },
  "common": {
    "unavailable": "해당 없음",
    "save": "저장",
    "cancel": "취소",
    "reset": "재설정",
    "close": "닫기",
    "retry": "재시도",
    "unknown": "알 수 없음",
    "confirm": "확인"
  },
  "journey": {
    "efficiency": "위상 효율성",
    "recentEfficiency": "최근 5분",
    "pathSummary": "중요한 순간",
    "pathValue": "{levels} 레벨 업 · {maps} 맵",
    "summaryLabel": "위상 효율성 요약",
    "level": "레벨",
    "expProgress": "현재 경험치",
    "map": "지도",
    "approximate": "교차 수준 추정",
    "confirmedPoint": "확인된 엔드포인트",
    "awaitingReading": "새로운 정확한 판독을 기다리는 중",
    "approximateHint": "교차 레벨 경험치는 이 기록 중에 추론된 레벨 요구 사항을 사용합니다.",
    "confirmedHint": "검증된 정확한 경험치 판독값에서",
    "efficiencyChartLabel": "클록 시간별 위상 효율 차트",
    "eventsLabel": "중요한 순간",
    "eventLevelUp": "Lv.{level}에 도달했습니다.",
    "eventMapChange": "{map}를 입력했습니다.",
    "mapChanged": "지도가 변경되었습니다",
    "minuteShort": "엠",
    "hourShort": "시간",
    "perHourShort": "/시간",
    "chartControls": "차트 컨트롤",
    "selectRange": "확대하려면 선택하세요.",
    "panChart": "팬 시간 범위",
    "zoomIn": "확대",
    "zoomOut": "축소",
    "resetZoom": "확대/축소 재설정",
    "earlier": "전기",
    "later": "후기",
    "eventGroup": "{time} · {count} 이벤트",
    "event": {
      "pause": "기록이 일시중지되었습니다.",
      "resume": "기록이 재개되었습니다",
      "capture-interrupted": "캡처가 중단되었습니다.",
      "capture-restored": "캡처가 복원되었습니다.",
      "rebaseline": "경험치 판독값이 재보정됨"
    }
  },
  "presets": {
    "worlds": { "name": "메이플스토리 월드", "description": "메이플스토리 월드 번체 중국어 인터페이스" },
    "label": "게임 프리셋",
    "auto": "자동(클래식/아르테일)",
    "gcw": { "name": "GCW", "description": "GCW 영어 인터페이스" },
    "artale": {
      "name": "아르테일",
      "description": "아르테일 중국어 번체 인터페이스"
    },
    "ambiguous": "여러 게임 인터페이스가 발견되었습니다. 게임 창을 하나만 표시하고 자동 인식을 다시 시도하세요.",
    "mxdc": {
      "name": "차이나 클래식",
      "description": "중국 클래식 서버 인터페이스"
    }
  },
  "live": {
    "expNetGain": "순 경험치",
    "expNetShort": "순 증가",
    "mesosLocate": {
      "inventoryOpen": "인벤토리가 열려 있나요?",
      "start": "자동 감지",
      "retry": "다시 감지",
      "retrySave": "저장 다시 시도",
      "recognizing": "감지 중…",
      "saving": "저장 중…",
      "locating": "재고와 메소 잔액을 눈에 띄게 유지하세요.",
      "located": "메소 영역을 찾았습니다. 잔액을 읽는 중…",
      "missing": "메소를 찾을 수 없습니다. 인벤토리를 열고 잔액이 보이도록 유지한 후 다시 시도하세요.",
      "timeout": "감지 시간이 초과되었습니다. 게임을 계속 표시한 후 다시 시도하세요.",
      "saveFailed": "메소 영역을 저장할 수 없습니다. 다시 시도해 주세요.",
      "failed": "메소 감지를 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
      "interrupted": "캡처 또는 인식 설정이 변경되었습니다. 다시 감지해주세요.",
      "disconnected": "게임 창을 연결하고 인벤토리를 열어 메소 잔액을 확인하세요.",
      "connecting": "게임 창을 연결합니다. 곧 감지 기능이 제공될 예정입니다.",
      "preparing": "인식을 준비 중입니다. 곧 감지 기능이 제공될 예정입니다.",
      "engineError": "인식이 불가능합니다. 다시 시도하려면 이 페이지의 지침을 따르세요.",
      "otherCalibration": "또 다른 교정이 진행 중입니다. 잠시 후 다시 시도해 주세요.",
      "unavailable": "기록 또는 설정을 처리 중입니다. 잠시 후 다시 시도해 주세요."
    },
    "empty": {
      "expPreviewHint": "기록을 시작하면 평균·실시간 효율과 레벨업 예상 시간을 표시합니다.",
      "expTitle": "경험치 데이터",
      "expHint": "경험치 진행 상황을 보려면 연결하세요. 레벨업 효율성을 측정하기 위해 기록을 시작합니다.",
      "expConnectedHint": "레벨과 경험치가 보이도록 유지하세요. 여기에 판독값이 표시됩니다.",
      "mesosTitle": "메소 데이터",
      "mesosHint": "인벤토리를 연결하고 열어 메소 잔액을 확인하세요.",
      "mesosConnectedHint": "인벤토리를 열고 메소 잔액이 보이도록 유지하세요.",
      "resourcesTitle": "캐릭터 상태",
      "resourcesHint": "건강과 마나를 확인하려면 연결하세요.",
      "resourcesConnectedHint": "HP와 MP를 눈에 띄게 유지하세요. 판독값이 자동으로 나타납니다.",
      "resourcesLabel": "HP / MP · BUFF 알림",
      "reading": "아직 읽지 않음",
      "maximum": "맥스 {value}",
      "startToCalculate": "계산을 위해 기록을 시작하세요",
      "waitingRate": "평가 데이터가 준비되지 않았습니다.",
      "cannotEstimate": "아직 추정할 수 없습니다",
      "connecting": "게임 화면을 연결합니다. 연결되면 읽기가 시작됩니다.",
      "preparing": "인식을 준비 중입니다. 읽기가 자동으로 시작됩니다.",
      "readingError": "인식이 불가능합니다. 페이지 지침에 따라 다시 시도하세요.",
      "reconnect": "게임 화면을 사용할 수 없습니다. 위의 지침에 따라 다시 연결하세요.",
      "trendTitle": "레벨업 효율 차트",
      "trendHint": "시간이 지남에 따라 효율성이 어떻게 변하는지 확인하려면 기록을 시작하십시오.",
      "trendPending": "트렌드 데이터 수집",
      "trendPendingHint": "위상 데이터를 사용할 수 있으면 추세가 나타납니다.",
      "diagnosticsTitle": "상태를 보려면 연결하세요.",
      "diagnosticsHint": "연결되면 여기에서 프레임 인식 및 데이터 업데이트를 확인하세요."
    },
    "title": "대시보드",
    "subtitle": "사냥 효율을 기록합니다. 게임 화면은 현재 기기에서만 처리됩니다.",
    "selectWindow": "게임 창 선택",
    "captureIdle": "게임 창을 기다리는 중",
    "captureHint": "브라우저는 실행 중인 메이플스토리 창을 선택하라는 메시지를 표시합니다.",
    "firstStep": "1단계",
    "onboardingTitle": "메이플스토리 창을 선택하세요",
    "onboardingHint": "Maple Log는 명시적으로 선택한 창만 읽습니다. 연결되면 데이터를 확인하고 기록을 시작하세요.",
    "gettingStarted": "시작하기",
    "guideWindow": "게임 창 선택",
    "guideCheck": "필요한 경우 교정",
    "guideRecord": "기록 시작",
    "calibrationShortcut": "인식 영역 보정",
    "calibrationShort": "보정",
    "capturePermissionDenied": "창 공유 권한이 부여되지 않았습니다. 게임 창을 다시 선택하세요. 공유 대화 상자가 표시되지 않으면 브라우저가 메시지를 차단하고 있지 않은지 확인하세요.",
    "captureSourceUnavailable": "선택한 캡처를 시작할 수 없습니다. 아래에서 다른 캡처 방법을 사용해 보세요.",
    "captureTimeout": "게임 화면 연결 시간이 초과되었습니다. 게임 창을 계속 표시하고 다시 선택하세요.",
    "captureUnsupported": "이 브라우저는 창을 캡처할 수 없습니다. 최신 Microsoft Edge, Google Chrome 또는 Firefox를 사용하세요.",
    "captureFailed": "게임창을 연결할 수 없습니다. 다시 선택하고 다시 시도하세요.",
    "captureRequesting": "연결 중",
    "captureSelecting": "소스 선택",
    "captureConnecting": "연결 프레임",
    "captureSelectingTitle": "브라우저 대화 상자에서 캡처 소스를 선택하세요",
    "captureConnectingTitle": "선택한 프레임 연결하기",
    "captureRetryWindow": "창을 다시 선택하세요",
    "captureSelectionSlow": "이 프레임을 선택하거나 연결하는 데 평소보다 시간이 오래 걸렸습니다. 선택기가 느린 경우 기록, 스트리밍 및 원격 데스크톱 도구를 닫고 열려 있는 창을 줄이고 브라우저와 그래픽 드라이버를 업데이트하세요.",
    "captureIssueSourceTitle": "게임 화면을 시작할 수 없습니다",
    "captureIssueSourceHint": "브라우저가 선택한 캡처를 시작할 수 없습니다. 전체 화면을 캡처해 볼 수 있습니다.",
    "captureIssueTimeoutTitle": "게임 화면 연결 시간이 초과되었습니다.",
    "captureIssueTimeoutHint": "브라우저가 선택한 캡처를 제때 받지 못했습니다. 게임을 계속 표시하거나 전체 화면을 캡처해 보세요.",
    "captureIssueUnsupportedTitle": "창 캡처는 지원되지 않습니다.",
    "captureIssueUnsupportedHint": "최신 Microsoft Edge, Google Chrome 또는 Firefox에서 Maple Log를 엽니다.",
    "captureIssueUnknownTitle": "게임창을 연결할 수 없습니다",
    "captureIssueUnknownHint": "게임 창을 다시 선택하세요. 그래도 실패하면 아래 복구 단계를 시도해 보세요.",
    "captureRecoveryMore": "아직도 연결할 수 없나요? 불필요한 창을 닫고 브라우저와 그래픽 드라이버를 업데이트하세요. 브라우저를 완전히 종료하거나, Win + Ctrl + Shift + B를 누르거나, 최신 Edge/Chrome/Firefox를 사용해 볼 수도 있습니다.",
    "captureActive": "창문이 연결됨",
    "captureInterrupted": "캡처가 중단되었습니다.",
    "start": "기록 시작",
    "pause": "일시중지",
    "resume": "이력서",
    "end": "기록 종료",
    "ending": "종료 중",
    "startConfirming": "경험치 확인 중",
    "startBaselineFailed": "현재 레벨과 경험치를 확인할 수 없습니다. 전체 경험치 영역이 표시되는지 확인한 후 다시 시도하세요.",
    "startBaselineSlow": "인식이 느리게 반응하고 있습니다. 게임을 계속 표시한 후 다시 시도하세요.",
    "startBaselineConfirming": "레벨과 경험치는 아직 확인 중입니다. 프레임을 안정되게 유지하고 다시 시도하십시오.",
    "startBaselineIncomplete": "전체 경험치 값을 확인할 수 없습니다. 경험치 숫자와 백분율을 모두 표시한 다음 다시 시도하십시오.",
    "startBaselineCaptureUnavailable": "게임 화면이 중단되었습니다. 게임 창을 다시 선택하고 다시 시도하세요.",
    "startWaitingFrame": "다음 프레임을 기다리는 중",
    "startRecognizing": "레벨과 경험치 읽는 중",
    "startFrameSlowTitle": "게임 화면이 천천히 도착하고 있습니다.",
    "startFrameSlowHint": "예상 샘플링 창 내에 새 프레임이 도착하지 않았습니다. 공유 창을 계속 표시하거나 취소하고 다시 시도하세요.",
    "startIssue": {
      "waitingEyebrow": "기록 준비 중",
      "confirmationLabel": "{metric} 확인",
      "eyebrow": "기록하기 전에 필요한 조치",
      "levelTitle": "현재 레벨은 확인되지 않았습니다",
      "expTitle": "완전한 경험치가 확인되지 않았습니다.",
      "slowTitle": "인식이 느리게 반응하고 있습니다.",
      "slowWaitingTitle": "이 기기에서는 인식 속도가 느립니다.",
      "slowWaitingReason": "정확한 시작 경험치를 확인하고 있습니다. 확인 후 시간을 측정하며 레벨 등은 나중에 채웁니다. 시작을 다시 누를 필요가 없습니다.",
      "expOneMore": "경험치가 인식되었습니다. 한 번 더 확인이 필요합니다(1/2). 게임을 눈에 띄게 유지하세요.",
      "confirmationProgress": "{metric} 확인: {confirmed} / {target}",
      "details": "인식 세부 정보",
      "refreshDetails": "세부 정보 새로고침",
      "noSnapshot": "아직 인식 스크린샷이 없습니다. 잠시 후 세부 정보를 새로고침하세요.",
      "expProgressRetained": "완전한 경험치 확인 1회를 유지했습니다(1/2). 다른 원본 프레임에서 완전한 값을 한 번 더 읽어야 합니다.",
      "engineTitle": "경험치를 읽을 수 없습니다",
      "captureTitle": "게임 화면이 중단되었습니다.",
      "detectedText": "이 시도의 OCR 텍스트",
      "levelConfirming": "레벨 {candidate}를 읽었지만 여전히 두 번째 독립적인 확인이 필요합니다.",
      "reasons": {
        "no-text": "실제 읽기 영역에서는 텍스트가 감지되지 않았습니다. 프레임을 확인하고 게임 UI가 보이도록 유지하세요.",
        "parse-failed": "텍스트가 감지되었지만 유효한 {metric} 데이터로 구문 분석할 수 없습니다.",
        "low-confidence": "{metric} 텍스트가 감지되었지만 품질이 엄격한 확인 기준을 충족하지 못했습니다.",
        "mixed-content": "프레임에는 LV 주변에 다른 숫자나 방해되는 내용이 포함되어 있어 레벨이 모호합니다.",
        "confirming": "후보 {metric} 값을 읽었지만 독립적인 샘플 확인이 완료되지 않았습니다.",
        "incomplete": "절대 경험치 값 또는 백분율은 불완전하며 정확한 시작점으로 사용할 수 없습니다.",
        "conflict": "경험치 수와 백분율은 동일한 프레임의 막대에 대해 확인할 수 없습니다.",
        "slow": "인식이 여전히 느린 프레임을 처리하고 있기 때문에 새로운 신뢰할 수 있는 수준과 경험치 쌍이 아직 도착하지 않았습니다.",
        "unresponsive": "전용 확인이 진행되지 않았고 인식 작업이 여전히 반환되지 않았습니다. 게임을 계속 표시하고 다시 시도하세요.",
        "engine-error": "경험치 인식에 실패하여 확인을 중단했습니다. 다시 시도하고, 계속 실패하면 게임 창을 다시 연결하세요.",
        "capture-unavailable": "게임 화면이나 공유 권한이 중단되어 정확한 시작점을 캡쳐할 수 없습니다."
      },
      "reviewFailure": {
        "no-text": "최신 리뷰에서는 텍스트가 발견되지 않았습니다. 인정된 수준의 후보 영역는 여전히 유지됩니다.",
        "parse-failed": "최신 리뷰에서는 유효한 수준을 구문 분석할 수 없습니다. 인정된 후보 영역는 여전히 유지됩니다.",
        "low-confidence": "최신 리뷰는 품질 기준점보다 낮았습니다. 인정된 후보 영역는 여전히 유지됩니다."
      },
      "path": {
        "legacy": "이 시도는 원래 인식 영역을 사용했습니다.",
        "adaptive": "이 시도는 자동으로 적응된 영역을 사용했습니다."
      },
      "guidance": {
        "level": "레벨 숫자 전체와 약간의 여백을 포함하세요(주황색 배지 또는 어두운 배경의 노란색 숫자). 숫자나 모서리를 자르거나 캐릭터 이름, 직업, 기타 숫자를 포함하지 마세요.",
        "exp": "전체 경험치 숫자와 백분율 텍스트를 포함하세요. 노란색 막대가 범위 안에 있을 필요는 없습니다."
      },
      "adjust": {
        "level": "레벨 영역 조정",
        "exp": "경험치 영역 조정"
      },
      "chooseWindow": "창을 다시 선택하세요",
      "retry": "다시 인식",
      "cancel": "취소 확인",
      "later": "나중에"
    },
    "pip": "위젯 열기",
    "pipUnsupported": "문서 PIP(Picture-in-Picture)를 사용할 수 없습니다.",
    "elapsed": "기록 시간",
    "expRate": "경험치 / 시간",
    "mesosRate": "메소 / 시간",
    "level": "레벨",
    "exp": "경험치",
    "mesos": "메소",
    "hp": "HP",
    "mp": "국회의원",
    "mapName": "현재 맵",
    "jobName": "직업",
    "mapPending": "맵 인식 중",
    "mapUncertain": "지도 미확인",
    "mapConfirming": "맵 확인 중",
    "currentRecord": "현재 기록",
    "recentTrend": "경험치 효율 추이",
    "noData": "기록을 시작하면 구간별 경험치 효율이 표시됩니다.",
    "trendChartLabel": "현재 기록의 구간별 효율",
    "modelReady": "OCR 리소스가 준비되어 있으며 이미지가 변경될 때만 인식이 실행됩니다.",
    "modelLoading": "OCR 리소스를 초기화하는 중입니다.",
    "modelError": "OCR 리소스를 사용할 수 없습니다. 계속하려면 새로고침하세요.",
    "diagnostics": "인식상태",
    "levelPending": "레벨 확인 대기",
    "coverageShort": "적용 범위",
    "coverageHint": "이 레코드의 첫 번째 신뢰할 수 있는 읽기부터 시작합니다. 누락된 데이터와 재사용된 캐시는 제외되며, 이후 검증된 업데이트에 따라 속도가 결정됩니다.",
    "expProgress": "현재 경험치",
    "startExp": "시작 경험치",
    "startLevel": "시작 Lv.{level}",
    "remainingExp": "다음 레벨로",
    "levelEta": "레벨업까지",
    "fullLevelDuration": "한 레벨 예상 소요 시간",
    "expGained": "이번 기록의 획득 경험치",
    "startSummary": "시작 Lv.{level} · {exp} 경험치",
    "expConfirmationFailure": {
      "invalid-exp-range": "경험치 숫자와 백분율을 읽었지만 이 읽기는 일관성 확인에 실패하여 확인에 포함되지 않습니다.",
      "incompatible-exp-samples": "두 개의 경험치 판독값을 서로 확인할 수 없습니다. 또 다른 확인이 필요합니다."
    },
    "readyToLevel": "레벨업 준비 완료",
    "lessThanMinute": "1분 이내",
    "estimateMinutes": "{count} 분",
    "estimateHours": "{hours} 시간 {minutes} 분",
    "estimateDays": "{days}일 {hours}시간",
    "inventoryRecognition": "보유 메소와 수익",
    "startMesos": "시작 메소",
    "currentMesos": "현재 메소",
    "balanceMesos": "보유 메소 변동",
    "netMesos": "기록 중 순 메소",
    "showBalanceComparison": "시작 잔액 및 잔액 변경 표시",
    "showTrackedMesos": "현재 잔액 및 추적 순액 표시",
    "disableRecognition": "인식하지 못함",
    "disableMetricRecognition": "{metric} 인식 중지",
    "restoreDefaultRecognition": "이력서 인식",
    "hideCard": "카드 숨기기",
    "mesosUnavailableHint": "인벤토리를 열고 메소 영역이 보이도록 유지하세요. 첫 번째 신뢰할 수 있는 잔액이 시작 잔액이 됩니다.",
    "mesosAvailableHint": "기록 중 순 메소에는 인벤토리가 보이는 동안 확인된 변화만 누적됩니다. 현재 잔액에서 시작 잔액을 뺀 값과 다를 수 있습니다.",
    "resourceStatus": "현황",
    "located": "위치를 찾았습니다.",
    "presetPosition": "기본 위치 사용",
    "processingLatency": "업데이트 속도",
    "retrying": "재시도 보류 중",
    "onDemand": "화면 업데이트",
    "gameLayout": "데이터 위치",
    "dataRefresh": "데이터 업데이트",
    "textReading": "텍스트 읽기",
    "windowConnection": "게임 창",
    "refreshWaiting": "프레임을 기다리는 중",
    "refreshSmooth": "부드러운",
    "refreshNormal": "보통",
    "refreshSlow": "조금 느림",
    "ready": "준비",
    "preparing": "준비 중",
    "ocrWaitingForWindow": "연결 후 시작",
    "unavailable": "이용 불가",
    "connected": "연결됨",
    "notConnected": "연결되지 않음",
    "status": {
      "ending": "종료 중",
      "idle": "시작되지 않음",
      "running": "기록",
      "paused": "일시중지됨",
      "ended": "종료됨",
      "interrupted": "연결 끊김"
    }
  },
  "calibration": {
    "pendingRawText": "아직 완료된 인식 결과가 없습니다",
    "ocrInputPreview": "실제 OCR 입력",
    "liveRegionPreview": "선택 영역 실시간 미리보기",
    "waitingFrame": "새 화면 대기 중",
    "mesosQueued": "OCR 대기 중",
    "taskScheduled": "작업 시작 시간",
    "taskCompleted": "작업 완료 시간",
    "completedStatus": "최근 완료 결과",
    "autoLocate": "자동 인식",
    "autoDialog": {
      "details": "위치 진단",
      "download": "캡처된 이미지 다운로드",
      "copy": "진단 복사",
      "copied": "진단이 복사되었습니다.",
      "exportFailed": "내보내기에 실패했습니다. 다시 시도해 주세요.",
      "capture": "캡처 크기",
      "scale": "UI 규모",
      "duration": "검색 기간",
      "confirmation": "확인",
      "confirmations": {
        "source-frames": "고유한 소스 프레임",
        "static-structure": "정적 구조 검증"
      },
      "reasons": {
        "timeout": "인식 시간이 초과되었습니다. 다시 시도해 주세요.",
        "not-found": "UI 구조를 찾을 수 없습니다. 완전한 게임을 보여주세요.",
        "too-small": "이미지가 너무 작거나 불분명합니다. 게임을 확대하세요.",
        "occluded": "불완전한 지역 구조; 덮힐 수도 있습니다.",
        "multiple-scenes": "여러 게임 화면가 감지되었습니다. 캡처 영역을 좁힙니다.",
        "unconfirmed": "후보 영역를 찾았으나 확인이 완료되지 않았습니다.",
        "capture-interrupted": "캡처가 중단되었습니다. 캡처를 재개하고 다시 시도하세요."
      },
      "stages": {
        "preparing": "준비 중",
        "locating": "지역 찾기",
        "saving": "위치 저장",
        "ended": "완료"
      },
      "count": "{count}/{total} 위치",
      "items": {
        "waiting": "대기 중",
        "confirming": "확인 중",
        "located": "위치",
        "saved": "저장됨",
        "missing": "찾을 수 없음"
      },
      "mesosMissing": "메소를 찾을 수 없습니다. 인벤토리를 열고 메소 영역이 보이도록 유지한 후 다시 시도하세요.",
      "retryMesos": "메소 재시도",
      "recognizing": "인식 중…",
      "keepInventoryVisible": "인벤토리와 메소 영역이 보이도록 유지하세요.",
      "retained": "이전 위치 유지",
      "cancel": "취소",
      "done": "완료",
      "retry": "모두 다시 인식",
      "retrySave": "저장 다시 시도",
      "keepVisible": "해당 지역이 확인되는 동안 게임을 계속 표시하세요.",
      "outcomes": {
        "complete": "모든 {total} 위치를 찾아 저장했습니다.",
        "partial": "{count} 위치가 저장되었습니다. 나머지 지역을 다시 찾아보세요.",
        "failed": "지역을 찾을 수 없습니다. 캡처를 표시한 상태로 두고 다시 시도하세요.",
        "saveFailed": "위치를 찾았지만 저장되지 않았습니다. 다시 저장해 보세요.",
        "cancelled": "취소. 기존 직위는 교체되지 않았습니다."
      }
    },
    "resetAllConfirmTitle": "모든 기본 위치 복원",
    "resetAllConfirmMessage": "7개 항목 모두의 기본 위치를 복원하시겠습니까? 이렇게 하면 수동 위치 조정이 삭제됩니다.",
    "resetAllConfirm": "기본값 복원",
    "resetAllCancel": "취소",
    "resetAllSuccess": "7개 항목 모두 기본 위치가 복원되었습니다.",
    "recognitionResult": "인식결과",
    "emptyRawText": "아직 읽은 텍스트가 없습니다.",
    "awaitingRegionRawText": "영역 확인 후 인식을 시작합니다",
    "expandRawText": "텍스트 확장",
    "collapseRawText": "텍스트 접기",
    "regionPreview": "지역 미리보기",
    "recognitionDetails": "인식 세부 정보",
    "resultStates": {
      "waiting": "인식 대기 중",
      "preparing": "인정 준비 중",
      "restoring": "기본값 복원",
      "disconnected": "캡처를 기다리는 중",
      "disabled": "인식 꺼짐",
      "running": "업데이트 중",
      "confirming": "확인 중",
      "success": "인식됨",
      "partial": "부분적으로 인정됨",
      "failed": "아직 인식되지 않음",
      "hidden": "메소 영역 숨김",
      "engineError": "인식불가"
    },
    "resultLabels": {
      "current": "현재 결과",
      "candidate": "결과 확인 대기 중",
      "previous": "이전 읽기"
    },
    "resultHints": {
      "mapTextClipped": "지도 텍스트가 잘릴 수 있습니다. 약간의 여백을 두고 전체 이름을 포함하세요.",
      "mapSuffixUncertain": "끝번호는 아직 불명. 전체 숫자가 보이는지 확인하세요. 인식이 자동으로 다시 시도됩니다.",
      "mapUncertain": "전체 지도 이름을 확인할 수 없습니다. 자동으로 다시 시도하는 중입니다. 마지막으로 확인된 지도는 사용 가능한 경우 유지됩니다.",
      "mapSuffixClipped": "지도 번호가 잘릴 수 있습니다. 프레임에 전체 이름과 접미사를 포함합니다.",
      "mapSuffixPending": "지도번호를 확인 중입니다. 마지막으로 확인된 지도는 사용 가능한 경우 유지됩니다.",
      "layoutUnavailable": "유효한 레이아웃 앵커가 누락되었습니다. 재배치; 게임을 눈에 띄게 유지하세요.",
      "resourceBarConflict": "텍스트와 막대가 일치하지 않습니다. 정확한 숫자는 허용되지 않습니다.",
      "newPosition": "위치가 조정되었습니다. 새로운 지역의 인식값을 기다리고 있습니다.",
      "locating": "인식 공간 찾기. 게임을 눈에 띄게 유지하세요.",
      "openInventory": "인벤토리를 열고 메소 영역이 보이도록 유지하세요.",
      "inventoryUnconfirmed": "메소 영역을 확인할 수 없습니다. 다시 찾는 중이니 인벤토리 전체를 표시해 주세요.",
      "noText": "텍스트가 감지되지 않았습니다. 읽을 내용에 맞게 프레임을 맞춥니다.",
      "parseFailed": "텍스트를 파싱할 수 없습니다. 다른 콘텐츠를 제외하려면 프레임을 조이세요.",
      "lowConfidence": "텍스트가 불분명합니다. 리딩 프레임과 게임 이미지를 확인해보세요.",
      "noResult": "아직 결과가 없습니다. 인식 공간을 깨끗하고 눈에 띄게 유지하십시오.",
      "partial": "일부 정보를 읽었습니다. 전체 숫자는 아직 확인되지 않았습니다.",
      "estimated": "이것은 추정치입니다. 정확한 숫자를 기다리고 있습니다.",
      "engineError": "인식 엔진이 준비되지 않았습니다. 대시보드에서 인식 리소스를 확인하세요."
    },
    "statisticsReview": "통계 검증",
    "statisticsReason": "통계 검증 이유",
    "mapConfirmationReason": "검토 이유",
    "statisticsStates": {
      "accepted": "통계 검증 통과",
      "pending": "검토 중인 통계",
      "rejected": "이번에는 사용하지 않음"
    },
    "initialize": "모든 기본값 복원",
    "initializing": "복원 중…",
    "restoreMetricHint": "{metric}에 대해서만 기본 위치 복원",
    "initializingHint": "지역 위치를 확인합니다. 게임을 눈에 띄게 유지하세요.",
    "initializeComplete": "7개 지역 모두 기본값으로 복원되어 저장되었습니다.",
    "initializePartial": "{count} 지역을 저장했습니다. {metrics}를 찾을 수 없습니다. 이 레이아웃의 기존 위치는 유지되었습니다. 전체 UI를 표시하고 다시 시도하세요.",
    "initializeFailed": "기본값 복원 또는 저장이 완료되지 않았습니다. 캡처를 표시한 상태로 유지하고 다시 시도하세요.",
    "mapConfirmationWait": "검토 대기",
    "mapConfirmationSeconds": "{count} 초",
    "mapConfirmationMethod": "확인방법",
    "mapConfirmationModes": {
      "independent-frames": "독립된 두 프레임으로 재검증",
      "suffix-frames": "독립 프레임에서 확인된 접미사",
      "cross-variant": "일치하는 변형",
      "stable-variant": "안정적인 반복 판독"
    },
    "mapConfirmationReasons": {
      "suffix-ambiguous": "지도 번호가 불분명합니다. 다른 프레임을 기다리는 중",
      "suffix-clipped": "지도 번호가 잘릴 수 있습니다. 인식 영역을 확인하세요",
      "collecting": "더 많은 독립 프레임을 기다리는 중",
      "conflict": "변형은 동의하지 않습니다. 안정성 비교",
      "unstable": "충분히 안정적인 결과가 없습니다. 나중에 다시 시도",
      "expired": "검토 시간이 초과되었습니다. 확인할 수 없습니다. 자동으로 재시도 중"
    },
    "title": "인식 위치 보정",
    "subtitle": "읽을 영역의 틀을 정하십시오. 조정 내용은 이 브라우저에 자동으로 저장됩니다.",
    "noCapture": "대시보드로 돌아가 먼저 게임 창을 선택하세요.",
    "goLive": "대시보드로 돌아가기",
    "autoLocated": "자동으로 발견됨",
    "fallback": "기본 위치 사용",
    "confidence": "읽기 품질",
    "selectedRoi": "데이터 항목",
    "expCreditedDelta": "신뢰할 수 있는 경험치가 이 샘플에 기여했습니다.",
    "expThreshold": "신뢰할 수 있는 이득 한도",
    "expDisplayValue": "표시된 경험치 엔드포인트",
    "expDisplayGain": "표시된 순이익",
    "expDisplayStatus": "계산 상태 표시",
    "expDisplayStates": {
      "ready": "가능",
      "stale": "새로운 인식값을 기다리며",
      "pending-transition": "확인 중",
      "unresolved-level": "불완전한 경험치 데이터",
      "unavailable": "완전히 읽지 않음"
    },
    "expAdmissionReasons": {
      "large-gain": "이득이 한도를 초과합니다. 제외된 간격",
      "level-correction": "레벨 보정; 확정된 레벨업 없음",
      "decrease": "경험치 감소; 기준선 검토",
      "requirement-conflict": "레벨 요구 사항이 충돌함",
      "recovery": "복구 후 검토",
      "invalid": "잘못된 경험치 데이터",
      "stale": "반복되거나 오래된 샘플"
    },
    "preview": "읽기 미리보기",
    "latestRecognition": "최신 인정",
    "statisticsValue": "통계에 사용",
    "confirmationProgress": "{current}/{target} 검토 중",
    "rawText": "OCR 텍스트",
    "barRatio": "유동비율",
    "readingStatus": "읽기 상태",
    "lastAttempt": "마지막 시도",
    "inferenceDuration": "추론 시간",
    "durationValue": "{value} ms",
    "enhancement": "향상",
    "enhancementValue": "변형 {index}",
    "levelEnhancements": {
      "color-smooth": "컬러 · 부드러움",
      "color-pixelated": "컬러 · 가장 가까운 이웃",
      "luminance-inverted": "반전 휘도 · 부드러움",
      "luminance-smooth": "휘도 · 부드러움",
      "luminance-pixelated": "휘도 · 가장 가까운 이웃"
    },
    "failureReasonLabel": "거부 이유:",
    "levelCorrected": "연속 판독으로 레벨 확인",
    "profile": "현재 프레임",
    "saved": "교정이 저장되었습니다",
    "strategy": "읽기 방법",
    "sourcePreview": "원본 보기",
    "processedPreview": "향상된 보기",
    "captureInfo": "프레임 세부정보",
    "help": "텍스트 상자를 이동하거나 크기를 조정합니다. 컬러 HP, MP 및 경험치 막대는 찾은 트랙에서 자동으로 확인되며 텍스트 프레임 안에 있을 필요는 없습니다.",
    "required": "사전 설정이 업데이트되었습니다. 인식 영역을 확인합니다. 현재 설정이 자동으로 저장됩니다.",
    "recommendedHint": "점선 윤곽선은 텍스트 읽기 영역입니다. 얇은 실선 윤곽선은 자동 확인된 색상 막대이며 OCR로 전송되지 않습니다.",
    "adjustedHint": "텍스트 범위가 자동으로 저장되었습니다.",
    "restoreDefault": "기본값 복원",
    "startGuidanceTitle": "기록가 되지 않는 부분을 수정하세요.",
    "startGuidance": {
      "level": "수준이 확실하게 확인되지 않았습니다. 아래 예를 사용하여 점선 텍스트 범위를 조정한 다음 두 번의 독립적인 판독을 위해 프레임을 안정적으로 유지합니다.",
      "exp": "완전한 경험치가 안정적으로 확인되지 않았습니다. 아래와 같이 프레임 경험치, 현재 값 및 백분율이 표시됩니다. 노란색 막대가 자동으로 확인됩니다."
    },
    "resize": "인식 영역 크기 조정",
    "roiLabel": "선택된 인식 영역",
    "overrides": "{count} 사용자 정의 영역",
    "strategyType": {
      "bar": "바 감지",
      "ocr": "텍스트 인식",
      "fused": "교차 확인됨",
      "unavailable": "이용 불가"
    },
    "positioning": "직위현황",
    "customPosition": "사용자가 조정함",
    "automaticPosition": "권장 범위",
    "adaptiveSearching": "적응",
    "adaptiveReady": "자동으로 축소됨",
    "adaptiveFallback": "검색 범위 사용",
    "searchRange": "검색 범위",
    "actualTextRange": "텍스트 읽기",
    "actualBarRange": "바 읽기",
    "framingGuide": "프레이밍 예시",
    "include": "포함",
    "exclude": "나가다",
    "guideSamples": {
      "nickname": "캐릭터 이름",
      "job": "직업 이름",
      "jobValue": "암살자",
      "minimap": "미니맵",
      "mapName": "숲속사냥터",
      "quest": "퀘스트 텍스트"
    },
    "guide": {
      "level": {
        "title": "읽기 전용 LV 및 레벨 번호",
        "include": "레벨 숫자 전체(주황색 배지 또는 어두운 배경의 노란색 숫자)와 약간의 여백",
        "exclude": "이름, 직업, 길드, 기타 번호"
      },
      "exp": {
        "title": "경험치 텍스트 행만 프레임 지정",
        "include": "경험치, 현재 값 및 백분율",
        "exclude": "아래 노란색 막대와 레벨, HP, MP 및 주변 텍스트"
      },
      "hp": {
        "title": "HP 숫자 행만 프레임에 넣습니다.",
        "include": "HP 라벨 및 현재/최대 값",
        "exclude": "아래 빨간색 막대와 MP, 경험치 및 주변 상태 텍스트"
      },
      "mp": {
        "title": "MP 번호 행만 프레임 지정",
        "include": "MP 라벨 및 현재/최대 값",
        "exclude": "아래 파란색 막대와 HP, 경험치 및 주변 상태 텍스트"
      },
      "mesos": {
        "title": "전체 메소 잔액 행 읽기",
        "include": "메소 아이콘과 전체 밸런스",
        "manualInclude": "전체 메소 잔액 (숫자만 선택해도 됩니다)",
        "exclude": "항목 수, 가격 및 기타 숫자"
      },
      "mapName": {
        "title": "현재 지도 이름만 읽기",
        "include": "전체 지도 이름 텍스트",
        "exclude": "미니맵 콘텐츠, 채널, 퀘스트 프롬프트"
      },
      "jobName": {
        "title": "직업명만 읽기",
        "include": "레벨 위와 오른쪽에 있는 전체 직업명",
        "exclude": "왼쪽이 레벨, 아래가 캐릭터 이름"
      }
    },
    "unsaved": "저장되지 않은 변경사항",
    "savedState": "변경사항이 저장되었습니다.",
    "autoSaving": "자동으로 저장",
    "autoSaved": "자동으로 저장됨",
    "autoSaveError": "자동 저장 실패",
    "autoSaveErrorHint": "교정 위치가 저장되지 않았습니다. 다시 시도하려면 다시 조정하세요.",
    "fineTune": "정밀한 위치 제어",
    "moveUp": "위로 이동",
    "moveDown": "아래로 이동",
    "moveLeft": "왼쪽으로 이동",
    "moveRight": "오른쪽으로 이동",
    "shrink": "인식 영역 축소",
    "expand": "인식 영역 확장",
    "status": {
      "disabled": "인식 꺼짐",
      "queued": "실행 대기 중",
      "running": "추론 실행",
      "ready": "확인됨",
      "confirming": "후보 영역 검토",
      "source-hidden": "메소 영역이 보이도록 유지",
      "no-result": "아직 읽은 내용이 없습니다.",
      "no-text": "텍스트가 감지되지 않았습니다.",
      "parse-failed": "텍스트를 파싱할 수 없습니다.",
      "low-confidence": "신뢰도가 너무 낮음",
      "corrected": "수정됨"
    },
    "failureReasons": {
      "capture-unavailable": "게임 화면 캡처가 중지되었거나 사용할 수 없습니다",
      "ocr-timeout": "OCR 처리 시간이 초과되어 재시도 중입니다",
      "ambiguous-exp": "경험치 필드 경계가 불분명하여 다시 인식 중입니다",
      "layout-unavailable": "유효한 레이아웃 앵커가 누락되었습니다.",
      "resource-bar-conflict": "텍스트와 막대 값이 일치하지 않음",
      "no-text": "선택한 영역에서 텍스트가 감지되지 않았습니다.",
      "parse-failed": "텍스트를 찾았지만 유효한 데이터로 구문 분석할 수 없습니다.",
      "low-confidence": "신뢰도가 현재 엄격함 설정보다 낮았습니다."
    }
  },
  "history": {
    "unknownMap": "알 수 없는 지도",
    "phaseEfficiency": "위상 효율성",
    "title": "기록 내역",
    "subtitle": "모든 기록의 핵심 요약은 이 장치에 유지됩니다.",
    "count": "{count} 레코드",
    "empty": "완료된 기록이 없습니다.",
    "emptyHint": "여기에서 핵심 요약을 보려면 실시간 기록을 완성하세요.",
    "duration": "기간",
    "expGained": "경험치 획득",
    "expPerHour": "경험치/시간",
    "mesosDelta": "순 메소",
    "pageLabel": "기록 페이지 매김",
    "loadFailed": "기록을 로드할 수 없습니다. 다시 시도해 보세요.",
    "expandJourney": "위상 효율 확장",
    "collapseJourney": "붕괴 단계 효율성",
    "journeyLoading": "위상 효율 데이터 로드 중",
    "journeyLoadFailed": "위상 효율 데이터를 로드할 수 없습니다.",
    "journeyRetry": "다시 로드해 보세요",
    "delete": "삭제",
    "deleteRecord": "이 기록 삭제",
    "deleteTitle": "내역 기록 삭제",
    "deletePrompt": "{date}에서 레코드를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
    "deleteDone": "기록이 삭제되었습니다.",
    "deleteFailed": "기록을 삭제할 수 없습니다. 다시 시도해 보세요.",
    "transferHint": "브라우저 간에 완료된 기록 및 단계 효율성 데이터를 이동합니다. 인식 및 보정 설정은 포함되지 않습니다.",
    "export": "기록 내보내기",
    "import": "수입기록",
    "exportDone": "{count} 내역 기록을 내보냈습니다.",
    "exportFailed": "기록을 내보낼 수 없습니다. 다시 시도해 보세요.",
    "importTitle": "기록 가져오기 확인",
    "importConfirm": "병합 가져오기",
    "importConfirmIntro": "{count} 기록 레코드를 병합합니다. 기존 로컬 레코드는 덮어쓰지 않습니다.",
    "importExportedAt": "내보낸 파일",
    "importDuplicates": "건너뛸 정확한 중복 항목",
    "importConflicts": "이름을 바꾸려면 ID가 충돌합니다.",
    "importMergeHint": "가져오기는 원자적으로 작성됩니다. 잘못된 레코드가 있으면 데이터가 기록되지 않습니다.",
    "importDone": "{imported}를 추가하고, {skipped} 중복을 건너뛰고, {remapped} 충돌 이름을 변경했습니다.",
    "importDisabledRecording": "기록을 가져오기 전에 현재 기록을 완료하세요.",
    "importTooLarge": "파일이 64MiB를 초과하여 가져올 수 없습니다.",
    "importInvalidJson": "파일이 유효한 JSON 기록 데이터가 아닙니다.",
    "importInvalidFormat": "이 기록 파일 형식은 인식되지 않습니다.",
    "importUnsupported": "이 기록 파일 버전은 지원되지 않습니다.",
    "importInvalidData": "기록 데이터가 불완전하거나 손상되었습니다. 아무것도 수입되지 않았습니다.",
    "importLimitExceeded": "기록 또는 위상 효율성 제한이 초과되었습니다.",
    "importWriteFailed": "역사는 기록될 수 없었다. 아무것도 수입되지 않았습니다.",
    "importFailed": "기록을 가져올 수 없습니다. 파일을 확인하고 다시 시도해 보세요.",
    "clear": "모든 기록 지우기",
    "clearTitle": "기록 지우기",
    "clearPrompt": "이렇게 하면 이 브라우저에 저장된 모든 기록이 영구적으로 제거됩니다.",
    "clearDone": "기록이 삭제되었습니다.",
    "clearFailed": "기록을 지울 수 없습니다. 다시 시도해 보세요.",
    "clearDisabledRecording": "기록을 지우기 전에 현재 기록을 완료하세요"
  },
  "rank": {
    "title": "사냥터 효율 순위",
    "subtitle": "레벨별, 직업별, 데이터 소스별 신뢰도 경험치 효율성 비교",
    "filters": "순위 필터",
    "levelBucket": "레벨 범위",
    "levelRange": "Lv.{start}–{end}",
    "job": "직업",
    "allJobs": "모든 직업",
    "jobRecords": "{count} 레코드",
    "source": "데이터 소스",
    "sourceName": {
      "all": "모든 소스",
      "mxdc": "小冊子",
      "fengji": "Maple Log"
    },
    "qualificationRule": "최소 {users} 플레이어와 유효한 기록 시간의 {duration}가 필요합니다. 각 플레이어는 유효한 시간의 {perUser}를 기록한 후 계산됩니다.",
    "tabs": "순위 유형",
    "formal": "집계 완료",
    "accumulating": "수집",
    "formalTitle": "집계 완료 순위",
    "formalHint": "이러한 맵은 비교를 위한 적격 사용자 및 신뢰할 수 있는 시간 임계값을 모두 충족합니다.",
    "accumulatingTitle": "데이터 수집",
    "accumulatingHint": "더 많은 플레이어 또는 유효한 기록 시간이 필요합니다. 이 경험치 요금은 참고용입니다.",
    "rank": "순위",
    "map": "맵",
    "typicalEfficiency": "일반적인 효율",
    "commonRange": "공통 효율 범위",
    "highReference": "고효율 참고값",
    "trustedSamples": "신뢰할 수 있는 샘플",
    "currentReference": "현재 일반 효율",
    "rateValue": "{value} 경험치/시간",
    "users": "{count}명",
    "hours": "{count} 시간",
    "sourceBreakdown": "Maple Log {fengji} · 小冊子 {mxdc}",
    "userProgress": "적격 사용자 {current}/{target}",
    "durationProgress": "신뢰할 수 있는 시간 {current}/{target}",
    "userThreshold": "공식 순위에 필요한 플레이어 수",
    "durationThreshold": "공식 순위에 소요되는 유효 시간",
    "resultCount": "맵 {count}개",
    "updatedAt": "데이터 업데이트됨 {time}",
    "rowUpdatedAt": "업데이트된 {time}",
    "refresh": "순위 새로고침",
    "retry": "다시 시도하세요",
    "loading": "순위 로드 중",
    "refreshing": "업데이트 중",
    "pagination": "순위 페이지 매기기",
    "statisticsHelp": "일반적인 효율성은 중간 결과를 나타냅니다. 공통 범위는 사용자 샘플의 중간 절반을 포함합니다. 효율성이 높은 기준은 속도 제한이 아닌 더 강력한 결과를 반영합니다.",
    "metadataWarning": "필터 메타데이터를 사용할 수 없습니다. 기본 범위와 임계값이 사용됩니다.",
    "metadataStaleWarning": "필터 메타데이터를 새로 고칠 수 없습니다. 기존 값은 계속 사용됩니다.",
    "emptyTitle": "아직 일치하는 지도가 없습니다.",
    "emptyFormalHint": "다른 수준 범위, 작업 또는 소스를 시도하거나 나중에 다시 확인하세요.",
    "emptyAccumulatingHint": "현재 이 필터에 대한 데이터를 수집하는 지도가 없습니다.",
    "error": {
      "network": "순위 서비스에 도달할 수 없습니다. 연결을 확인하고 다시 시도하세요.",
      "response": "순위 서비스를 일시적으로 이용할 수 없습니다. 나중에 다시 시도하세요.",
      "invalid-data": "순위 서비스에서 반환된 데이터 Maple Log를 읽을 수 없습니다. 나중에 다시 시도하세요."
    }
  },
  "changelog": {
    "title": "업데이트 내역",
    "subtitle": "Maple Log의 새로운 기능, 개선 사항 및 수정 사항입니다.",
    "timelineLabel": "Maple Log 출시",
    "latest": "현재",
    "directory": "이 페이지에서",
    "changeCount": "{count} 변경 사항",
    "categories": {
      "added": "새로운 기능",
      "improved": "개선 사항",
      "fixed": "수정"
    },
    "announcement": {
      "title": "새로운 소식",
      "history": "업데이트 기록 보기",
      "dismiss": "알았어요",
      "close": "업데이트 공지 닫기"
    },
    "releases": {
      "update20261031": {
        "items": {
          "gcwPercentageExp": { "title": "GCW 경험치 백분율", "description": "경험치가 백분율로만 표시될 때도 획득량과 효율을 추정할 수 있습니다." },
          "historyRecovery": { "title": "기록 데이터 구출", "description": "사용 가능한 기록을 내보내고 문제가 있는 원본 데이터를 별도로 저장할 수 있습니다." },
          "widgetSkins": { "title": "위젯 스킨", "description": "12가지 테마를 새로 디자인하고 다양한 창 크기에서의 표시를 개선했습니다." },
          "precisionCalibration": { "title": "인식 보정", "description": "확대, 픽셀 단위 미세 조정, 게임 유형 직접 전환을 지원합니다." },
          "personalMapReference": { "title": "개인 사냥터 참고 정보", "description": "효율 범위 계산을 개선해 평소 사냥 성과를 더 잘 반영합니다." },
          "experienceRecognition": { "title": "경험치와 상태", "description": "경험치·HP／MP 인식과 갱신 지연을 개선하고 일부 레벨업 집계 오차를 수정했습니다." },
          "buffReminders": { "title": "BUFF 알림", "description": "아이콘 인식을 개선하고 여러 알림이 동시에 발생할 때의 음성 누락과 만료된 알림의 지연 재생을 수정했습니다." },
          "captureRecovery": { "title": "화면 공유 복구", "description": "캡처 중단 오판을 수정하고 페이지로 돌아오거나 다시 공유한 뒤의 복구를 개선했습니다." }
        }
      },
      "update20261027": {
        "items": {
          "personalMapReference": { "title": "내 사냥 맵 기록 참고", "description": "랭킹에서 기록한 맵을 표시하고, 현재 브라우저에 저장된 과거 효율 범위를 보여줍니다." },
          "rankEntry": { "title": "맵 랭킹", "description": "맵 랭킹을 열면 현재 레벨과 직업에 맞는 결과를 자동으로 표시합니다." },
          "liveDashboard": { "title": "대시보드", "description": "경험치·메소·차트 배치를 조정하고, 상태 안내와 좁은 화면에서의 표시를 개선했습니다." },
          "buffAlerts": { "title": "BUFF 알림", "description": "종료 임박 표시를 강화하고 위젯 아이콘을 키웠습니다." },
          "expPreview": { "title": "경험치 미리보기", "description": "미리보기와 확정된 인식값이 일치하지 않는 문제를 수정했습니다." },
          "mesosRecognition": { "title": "메소 인식", "description": "일부 상황에서 메소가 제대로 인식되지 않는 문제를 수정했습니다." },
          "resourceLoading": { "title": "음성과 리소스", "description": "새로고침, 느린 네트워크 및 요청 제한 상황에서의 로딩 문제를 개선했습니다." }
        }
      },
      "update20261025": {
        "items": {
          "customBuffAudio": { "title": "BUFF 사용자 지정 오디오", "description": "알림 소리를 업로드, 미리 듣기, 관리할 수 있으며 현재 브라우저에만 저장됩니다." },
          "mapEfficiency": { "title": "맵 참고 효율", "description": "직업 매칭과 표시를 개선했습니다." },
          "rankFilters": { "title": "랭킹 필터", "description": "직업 아이콘, 배치 간격, 펼치기 애니메이션을 개선했습니다." },
          "buffSearch": { "title": "BUFF 검색", "description": "GCW에서 여러 BUFF의 검색과 재인식을 개선했습니다." },
          "buffCountdown": { "title": "BUFF 남은 시간", "description": "일반 모드에서 숫자가 사라지면 기존 타이머와 아직 재생되지 않은 알림을 일시 중지합니다." },
          "buffIcons": { "title": "아이콘 인식", "description": "GCW에서 작게 표시된 헤이스트 아이콘의 인식 누락을 개선했습니다." }
        }
      },
      "update20261023": {
        "items": {
          "multiJobFilter": { "title": "여러 직업으로 필터링", "description": "랭킹에서 여러 직업을 동시에 선택할 수 있습니다. 직업군, 계열 또는 특정 전직을 조합해 필터링하세요." },
          "buffManagement": { "title": "설정에서 BUFF 관리", "description": "설정 페이지에서 BUFF를 추가하고 관리할 수 있습니다. 게임에 연결하지 않아도 알림을 설정할 수 있습니다." },
          "sessionStart": { "title": "더 원활한 기록 시작", "description": "경험치가 확인되면 바로 시간 측정을 시작하고, 레벨과 맵 등의 정보는 이후에 보완합니다." },
          "gameRecognition": { "title": "게임 화면 인식", "description": "클래식 화면의 경험치 오인식과 읽기 중단, GCW의 레벨 및 맵 인식을 개선했습니다." },
          "expAccounting": { "title": "경험치 집계", "description": "일부 레벨업, 사망 및 재연결 상황에서 발생하던 경험치 집계 오차를 수정했습니다." },
          "buffRecognition": { "title": "BUFF 인식", "description": "비슷한 아이콘의 오인식과 남은 시간의 잘못된 초기화를 줄이고, BUFF 추가 시 입력 검증과 기본 설정을 수정했습니다." }
        }
      },
      "update20261020": {
        "items": {
          "manboVoice": { "title": "Manbo 음성 알림", "description": "중국어 알림은 기본적으로 Manbo 음성을 사용합니다. 시스템에서 제공하는 광둥어, 대만 표준 중국어 등의 음성도 선택할 수 있습니다." },
          "manualBuffTimer": { "title": "BUFF 수동 타이머", "description": "유효한 남은 시간을 처음 인식하면 독립적으로 시간을 측정하고, 종료 시 설정한 주기로 반복합니다. 이후 게임 화면이 가려져도 영향을 받지 않습니다. 수동 모드는 게임 내 BUFF 갱신과 동기화되지 않으며 연결을 끊으면 중지됩니다." },
          "dropSellPrice": { "title": "드롭 아이템 판매 가격 표시", "description": "드롭 아이템 상세 정보에 판매 가격을 추가해 아이템 가치를 확인할 수 있습니다." },
          "sessionAutosave": { "title": "기록 자동 저장", "description": "기록 중 60초마다 진행 상황을 저장해 페이지가 예기치 않게 닫힐 때 데이터 손실을 줄입니다." },
          "runtimePerformance": { "title": "실행 부하 감소", "description": "저부하 모드의 인식 스케줄링을 개선하고 위젯, 일일 패널, 경험치 차트의 중복 계산을 줄였습니다." },
          "dashboardCards": { "title": "더 유연한 대시보드", "description": "인식을 끄면 메소 또는 HP／MP 영역을 숨길 수 있으며 BUFF는 계속 표시됩니다." },
          "buffCountdown": { "title": "더 안정적인 BUFF 남은 시간", "description": "복잡한 배경과 작은 숫자 인식을 개선해 남은 시간 표시 중단, 오인식, 알림 누락을 줄였습니다." },
          "recognitionAccuracy": { "title": "경험치·메소·상태 인식", "description": "경험치, 메소, HP／MP 읽기를 개선해 고해상도 화면에서 인식 안정성을 높였습니다." }
        }
      },
      "update20261014": {
        "items": {
          "experienceSettings": { "title": "경험치 설정", "description": "레벨업 예상은 기본적으로 실시간 속도를 사용하도록 변경했습니다. 평균 속도로 전환하거나 시간／분 표시 단위를 선택할 수 있습니다." },
          "attributeRecognition": { "title": "능력치 창 인식", "description": "중국 클래식 서버에서는 능력치 창에서 레벨, 직업, 경험치, HP／MP를 읽고, 사용할 수 없으면 하단 상태창으로 전환합니다." },
          "recognitionPerformance": { "title": "인식 성능", "description": "화면 캡처를 최적화하고 중복 계산과 이미지 읽기를 줄였습니다. 4K 테스트 조건에서 BUFF의 프레임당 이미지 읽기량이 약 23% 감소했습니다." },
          "journeyChart": { "title": "레벨업 효율 차트", "description": "시간 범위 전환, 평균선, 최고값, 맵 및 중단 구간 표시를 추가했습니다. 클릭하여 측정값을 고정할 수 있습니다." },
          "gcwRecognition": { "title": "GCW 인식", "description": "울트라와이드 화면에서 상태창, 맵, 메소 영역의 위치 인식을 개선했습니다." },
          "buffCountdown": { "title": "BUFF 남은 시간 오인식", "description": "일부 컬러 및 작은 글씨의 BUFF 남은 시간 오인식을 수정했습니다." },
          "widgetDisplay": { "title": "위젯 표시", "description": "위젯 글자 넘침, 레이아웃 복원 및 레벨업 예상 표시 문제를 수정했습니다." },
          "expChartContinuity": { "title": "경험치 차트 끊김", "description": "경험치 재확인 중 정상적인 차트가 불필요하게 끊기는 문제를 수정했습니다." },
          "captureFrameRate": { "title": "캡처 프레임률 제한", "description": "일부 상황에서 캡처 프레임률 제한이 올바르게 적용되지 않는 문제를 수정했습니다." }
        }
      },
      "update20261010": {
        "items": {
          "historyTools": { "title": "기록 이용 경험 개선", "description": "맵별 통계, 기록 검색, 두 기록 비교, 일괄 삭제를 추가하고 분할 화면에서 상세 정보를 볼 수 있도록 했습니다." },
          "widgetWindowModes": { "title": "위젯 열기 방식 추가", "description": "항상 위에 표시되는 화면 속 화면 또는 독립 창을 선택할 수 있으며, 마지막 선택을 기억합니다." },
          "gcwRecognition": { "title": "GCW(국제 클래식 서버) 인식 개선", "description": "작은 화면과 경험치·메소 읽기를 개선하고, 인벤토리 이동이나 수동 영역 지정 후의 인식 복구를 개선했습니다." },
          "buffDetection": { "title": "BUFF 인식 누락 수정", "description": "경험치 증가 등 BUFF 아이콘이 이동한 후 인식되지 않는 문제를 줄였습니다." }
        }
      },
      "update20261008": {
        "items": {
          "gcwSupport": { "title": "GCW(국제 클래식 서버) 지원 추가", "description": "영어 게임 화면에 자동으로 맞춰 레벨, 경험치, HP, MP, 메소, 맵, 직업을 인식합니다." },
          "defaultWidget": { "title": "기본 위젯 개편", "description": "경험치 효율, 실시간 속도, 레벨 진행률, BUFF 배치를 새롭게 구성했습니다. 기존 기본 스타일은 클래식으로 계속 사용할 수 있습니다." },
          "compactWidget": { "title": "작은 창 표시 개선", "description": "좁은 창에서 수치, 버튼, 기록 시간 배치를 개선해 잘림과 겹침을 줄였습니다." }
        }
      },
      "update20261005": {
        "items": {
          "historyStatistics": { "title": "기록 페이지 개편", "description": "일·주·월별 획득량과 효율을 확인할 수 있으며, 추이 그래프와 기록 달력, 이전 기간 비교를 지원합니다." },
          "expRecognition": { "title": "경험치 이상 수정", "description": "경험치 오인식과 비정상적인 속도를 줄이고, 읽기 복구와 메인 화면·위젯 표시의 일관성을 개선했습니다." },
          "expRateExplanation": { "title": "효율 설명 개선", "description": "기록 전체 평균과 최근 60초 효율을 구분하고, 그래프 데이터 수집 진행 상황을 표시합니다." },
          "buffRecognition": { "title": "BUFF 인식 개선", "description": "해상도별 아이콘과 남은 시간 인식을 개선하고, 비슷한 아이콘을 혼동하는 경우를 줄였습니다." },
          "widgetExperience": { "title": "위젯 개선", "description": "첫 사용 시 크기 조절 안내와 직업 정보를 추가하고, 버튼과 경험치 그래프 배치를 조정했습니다." }
        }
      },
      "update20260930": {
        "items": {
          "currentMap": { "title": "현재 지도", "description": "기록 중 인식한 지도와 몬스터, 드롭 아이템을 확인하고 비슷한 레벨대와 직업의 사냥 효율을 참고할 수 있습니다." },
          "dropDetails": { "title": "드롭 정보", "description": "지도 상세에 드롭률과 해당 몬스터 정보를 추가하고, 몬스터별로 드롭 아이템을 필터링할 수 있게 했습니다." },
          "liveLayout": { "title": "대시보드 화면 배치 개선", "description": "레벨업 그래프와 현재 지도 정보를 더 쉽게 볼 수 있도록 대시보드 화면의 배치를 조정했습니다." },
          "skinPreview": { "title": "위젯 스킨 미리보기 개선", "description": "스킨을 선택하거나 살펴볼 때 다양한 창 크기를 보여 주고, 테디 애니메이션과 이미지도 업데이트했습니다." },
          "widgetRecovery": { "title": "위젯 표시 오류 수정", "description": "표시 오류에서 더 잘 복구하도록 개선해 콘텐츠 오류가 기록 시작, 일시 중지, 종료에 영향을 주지 않도록 했습니다." },
          "shortSessions": { "title": "너무 짧은 기록 정리", "description": "종료 후 5초 미만인 기록은 더 이상 기록 내역에 남지 않습니다." }
        }
      },
      "update20260928": {
        "items": {
          "realtimeRateChart": { "title": "실시간 속도 추이 그래프", "description": "실시간 화면과 위젯에 최근 5분 경험치 속도 그래프를 추가했습니다. 레벨업 페이스를 더 쉽게 파악할 수 있습니다." },
          "widgetLayout": { "title": "위젯 레이아웃 개선", "description": "위젯 안 정보 배치와 간격을 다듬어 핵심 수치와 속도 그래프가 스킨과 창 크기에 관계없이 더 잘 보이도록 했습니다." }
        }
      },
      "update20260924": {
        "items": {
          "buffAlerts": { "title": "BUFF 알림", "description": "확인하고 싶은 BUFF를 추가하면 게임 화면 연결 후 자동으로 모니터링합니다. 종료 직전이나 사라졌을 때 음성 안내와 아이콘 깜박임으로 알려줍니다." },
          "rateUnits": { "title": "시간·분 단위 전환", "description": "경험치와 메소 획득 속도를 시간당 또는 분당으로 표시할 수 있습니다. 설정에서 단위를 바꿔도 통계 결과는 변경되지 않습니다." },
          "lightweightOcr": { "title": "경량 문자 인식 모델", "description": "기기 부하를 줄이는 경량 모델과 인식 정확도가 높은 표준 모델 중 선택할 수 있습니다." },
          "artaleSupport": { "title": "Artale 지원", "description": "Artale 게임 화면을 인식하고 해당 화면 구성에 맞춰 캐릭터와 레벨업 데이터를 읽을 수 있습니다." },
          "newLanguages": { "title": "화면 언어 3종 추가", "description": "번체 중국어, 일본어, 한국어를 지원하며 설정에서 변경할 수 있습니다." },
          "userExperience": { "title": "사용 경험 개선", "description": "설정, 인식, 데이터 표시의 세부 동작을 다듬어 자주 쓰는 기능을 더 쉽게 찾고 사용할 수 있습니다." },
          "recognitionAccuracy": { "title": "인식 정확도 개선", "description": "화면 위치 탐색과 문자 읽기를 개선해 일부 상황에서 잘못 읽거나 놓치는 경우를 줄였습니다." },
          "widgetDisplay": { "title": "위젯 표시 오류 수정", "description": "일부 크기나 상태에서 위젯 내용이 잘못 표시되던 문제를 수정했습니다." },
          "styleIssues": { "title": "화면 스타일 문제 수정", "description": "일부 페이지와 컨트롤의 표시 세부 사항을 조정했습니다." }
        }
      },
      "update20260918": {
        "items": {
          "rankPageRebuild": {
            "title": "새롭게 디자인된 순위 페이지",
            "description": "더욱 명확한 레이아웃과 풍부한 세부정보를 갖춘 지도 드롭 및 지도 검색이 추가되었습니다."
          },
          "browserCompatibility": {
            "title": "더 많은 브라우저에서 작동",
            "description": "공식 Edge 또는 Chrome이 아닌 브라우저에서도 가능하면 창을 선택하고 위젯을 열 수 있습니다. Always-on-Top 또는 인식을 사용할 수 없는 경우 Maple Log가 그 이유를 설명합니다. 최신 Edge와 Chrome은 변경되지 않았습니다."
          },
          "captureTimeout": {
            "title": "더욱 안정적인 연결",
            "description": "창을 처음 선택할 때나 사이트를 다시 연 후에 정지되거나 회전할 가능성이 줄어듭니다."
          }
        }
      },
      "update20260914": {
        "items": {
          "realtimeExpRate": {
            "title": "실시간 경험치 속도",
            "description": "경험치/hour는 마지막 순간이 세션 평균보다 빠른지 느린지를 보여줍니다. 분기되면 화살표가 나타납니다. 자세한 내용을 보려면 마우스를 올리세요."
          },
          "firstUseAutoLocate": {
            "title": "첫 번째 연결 시 자동 인식",
            "description": "자동 인식은 게임 창을 처음 연결할 때 열립니다. 상태 표시줄을 계속 표시하세요. 인벤토리를 열어 메소도 찾으세요. 건너뛸 수 있습니다."
          },
          "clearerMetrics": {
            "title": "더욱 명확한 실시간 측정항목",
            "description": "보조 필드는 숨겨져 있으므로 경험치 및 메소 속도와 같은 핵심 값이 눈에 띕니다."
          }
        }
      },
      "update20260913": {
        "items": {
          "autoLocateMesos": {
            "title": "메소 자동 찾기",
            "description": "인벤토리를 열고 메소가 보이는 상태로 유지하면 자동 인식으로 찾을 수 있습니다. 누락된 경우 메소만 다시 시도하세요."
          },
          "factoryReset": {
            "title": "공장 초기화",
            "description": "설정에서는 기록, 기본 설정, 인식 리소스를 지울 수 있습니다. 시작 및 캡처 실패도 여기에 해당됩니다."
          },
          "pipWindowSize": {
            "title": "PiP는 크기를 기억합니다",
            "description": "위젯이 마지막으로 사용한 크기로 다시 열립니다."
          },
          "calibrationPreview": {
            "title": "더 쉬워진 교정 프레이밍",
            "description": "미리보기는 캡처 화면 비율을 유지하므로 작은 상자에서도 쉽게 잡을 수 있습니다."
          },
          "recoveryPaths": {
            "title": "더 많은 복구 방법",
            "description": "설정이나 캡처에 실패하면 공장 설정을 복원하거나 브라우저를 업데이트하세요. 자동 인식 시간 초과도 표시됩니다."
          },
          "highDpiRecognition": {
            "title": "고해상도 인식 오류",
            "description": "영역은 캡처된 픽셀에 위치하므로 게임 내 해상도가 캡처 크기와 일치할 필요는 없습니다. HUD 검색은 약 0.5×–4× UI 규모를 다룹니다."
          },
          "upgradeExpAccounting": {
            "title": "레벨 업은 더 이상 경험치 손실로 계산되지 않습니다.",
            "description": "갑자기 경험치 드롭이 레벨 확인을 기다립니다. 확인된 레벨 업이 인정됩니다. 확인되지 않은 실행은 음수가 아닌 불완전한 것으로 표시됩니다."
          }
        }
      },
      "update20260910": {
        "items": {
          "newLayoutAutoLocate": {
            "title": "새로운 게임 UI 및 자동 인식",
            "description": "레벨, 직업, HP, MP, 경험치, 맵 이름을 한 번에 찾아냅니다. 메소는 여전히 인벤토리가 열린 상태에서 수동 프레이밍이 필요합니다. 진행 상황 및 진단 내보내기를 통해 다양한 크기와 UI 규모를 지원합니다. 찾을 수 없는 항목을 다시 시도하세요."
          },
          "rankMapTip": {
            "title": "순위에 대한 지도 정보",
            "description": "지도 이름 위에 마우스를 올리거나 미니맵, 지역, 몬스터, NPC 및 관련 메모에 대한 세부정보를 탭하세요."
          },
          "calibrationSimpler": {
            "title": "더욱 간단한 교정",
            "description": "HP, MP 및 경험치 텍스트 행만 프레임에 넣습니다. 막대가 자동으로 확인됩니다. 위치는 캡처 크기별로 저장되며 기본값으로 한 단계 복원되고 더 명확한 결과와 거부 이유가 제공됩니다."
          },
          "jobLineRecognition": {
            "title": "더욱 정확한 직무 인식",
            "description": "OCR 이전에 직업명 줄을 찾아 작업으로 잘못 읽는 수준이나 캐릭터 이름을 줄입니다."
          }
        }
      },
      "update20260909": {
        "items": {
          "recognitionPerformance": {
            "title": "주요 인식 성능 개선 및 재설계된 설정",
            "description": "5가지 사전 설정(낮음, 중간, 기본값, 높음, 매우 높음)이 캡처 및 인식 속도를 함께 제어합니다. 새 사용자 및 마이그레이션된 설정은 기본값을 사용합니다. 낮음 및 중간은 업데이트 속도를 늦추어 로드를 줄입니다. 작업 표시줄이 멈추고 응답하지 않는 문제도 해결되었습니다."
          },
          "hpMpRates": {
            "title": "HP/MP 소모율 삭제",
            "description": "이제 라이브 페이지와 위젯에는 현재 HP/MP, 최대값, 상태 표시줄만 표시됩니다. 소비, 회복, 시간당 요금이 제거됩니다. 역사 카드는 지도, 캐릭터, 경험치 및 메소를 강조합니다."
          },
          "lowFrequencyMesos": {
            "title": "더 낮은 판독 주파수에서 더욱 안정적인 메소 추적",
            "description": "읽기 속도가 느려지면 이제 재고가 열려 있는 동안 순이익 추적이 유지됩니다. 닫거나, 프레임이 불확실하거나, 공유 소스를 일시 중지하거나 전환하면 여전히 연속성이 끊어집니다."
          },
          "mapRomanSuffix": {
            "title": "지도 이름 접미사에서 로마 숫자 인식 문제를 수정했습니다.",
            "description": "인식은 잘못 읽은 로마 숫자 접미사(예: III)를 복원하여 잘리거나 분할된 지도 이름을 줄이려고 시도합니다."
          }
        }
      },
      "update20260908": {
        "items": {
          "streamSkins": {
            "title": "위젯 스킨",
            "description": "부드러운 유휴 및 레벨 업 애니메이션과 함께 Adventure HUD, Minimal Report, Mushroom Companion, Snowfield Expedition, 루디브리엄 Block Station, 핑크빈 Radio, Kerning Graffiti 및 Aqua Voyage를 추가했습니다. 오르비스, 사쿠라 가든, 아케인 스타라이트를 대체합니다."
          },
          "streamConnect": {
            "title": "스트리밍 설정 가이드",
            "description": "설정의 새로운 가이드는 위젯 열기, 키 색상 선택, OBS 또는 유사한 도구에 창 캡처 및 크로마 키 필터 추가 과정을 안내합니다."
          },
          "allLevelRankings": {
            "title": "모든 레벨의 순위 보기",
            "description": "이제 지도 순위는 모든 레벨을 지원하며, 각 레벨 범위는 공정한 효율성 비교를 위해 별도로 계산 및 표시됩니다."
          },
          "localDiagnostics": {
            "title": "성능 및 로컬 진단",
            "description": "이제 설정에서는 부하를 줄이기 위해 별도의 캡처 및 프레임 검사 속도 제한을 제공합니다. 자동 업로드, 스크린샷, OCR 텍스트 또는 창 제목 없이 로컬 진단을 보거나 복사하거나 다운로드합니다."
          },
          "screenCaptureFallback": {
            "title": "창 캡처 실패 시 화면 캡처로 전환",
            "description": "창 캡처에 실패하면 전체 화면을 캡처해 보세요. 문제 해결에서는 피드백을 위해 복사할 수 있는 진단과 함께 창 모드, 브라우저 및 그래픽 드라이버를 다룹니다."
          },
          "recognitionRecovery": {
            "title": "더욱 안정적인 인식과 원활한 복구",
            "description": "변경되지 않은 프레임은 반복되는 향상이 덜 필요합니다. OCR 재시도는 연속 실패 후 속도가 느려지고 성공 후 정상으로 돌아가므로 지연 및 반복 재설정이 줄어듭니다."
          },
          "captureFailureGuidance": {
            "title": "더 명확한 캡처 실패 메시지",
            "description": "이제 캡처 실패, 시간 초과 및 일시적 사용 불가에 대한 설명이 화면 캡처, 창 재선택 및 추가 문제 해결 옵션과 함께 제공됩니다."
          },
          "jobRecognition": {
            "title": "직업 지역 레벨이나 캐릭터 이름이 잘못 읽혀지는 현상",
            "description": "주변 레벨이나 캐릭터 이름을 직업으로 오독하는 현상을 줄이기 위해 직업 인식 영역을 강화했습니다."
          }
        }
      },
      "update20260907": {
        "items": {
          "mapRanking": {
            "title": "레벨업 맵 순위(베타)",
            "description": "레벨 범위, 직업, 데이터 소스별로 지도 경험치 효율성을 비교하여 훈련할 위치를 선택하는 데 도움을 받으세요."
          },
          "widgetSkins": {
            "title": "위젯 스킨",
            "description": "레벨업 표시를 개인화하려면 설정의 새로운 위젯 스킨 중에서 선택하세요."
          },
          "efficiencyChart": {
            "title": "재설계된 효율성 추세",
            "description": "레벨업 진행 상황을 더 명확하게 확인하세요. 대시보드 및 기록의 단계 효율성 차트는 드래그하여 확대/축소, 시간 이동 및 두 번 클릭하여 전체 보기를 복원하는 기능을 지원합니다."
          },
          "calibrationExamples": {
            "title": "교정 선택 예",
            "description": "새로운 지역 선택 예제는 게임 화면에 대해 인식 영역을 보정하는 데 도움이 됩니다."
          },
          "autoRegion": {
            "title": "자동 지역 감지",
            "description": "인식 영역이 자동으로 위치하므로 수동 선택 및 보정이 줄어듭니다."
          },
          "recognitionPerformance": {
            "title": "주요 인식 성능 개선",
            "description": "게임 화면 속도에 미치는 영향을 최소화하고 원활한 기록를 유지하기 위해 인식 오버헤드를 크게 줄였습니다."
          },
          "startFeedback": {
            "title": "기록를 시작할 수 없는 명확한 이유",
            "description": "레벨 또는 전체 경험치 판독값이 확인되지 않거나, 인식이 느리거나, 화면 공유가 중단되는 경우 대화 상자에서 원인을 설명하고 조정 옵션을 제공합니다."
          },
          "responsiveWidget": {
            "title": "더욱 유연한 위젯 레이아웃",
            "description": "개선된 반응형 레이아웃을 통해 위젯의 크기를 컴팩트에서 와이드까지 자유롭게 조정할 때 데이터 읽기가 유지됩니다."
          },
          "firefoxCompatibility": {
            "title": "Firefox 호환성 수정",
            "description": "Firefox에서 앱이 제대로 작동하지 않는 문제를 수정했습니다."
          },
          "recordingStart": {
            "title": "기록 시작 수정",
            "description": "일부 플레이어가 기록를 시작하지 못하는 문제를 수정하여 시작 안정성을 향상했습니다."
          }
        }
      },
      "update20260904": {
        "items": {
          "expRate": {
            "title": "경험치 환율",
            "description": "시간당 경험치는 획득한 경험치를 기록 지속 시간으로 나누어 사용하여 레벨 업 전반에 걸쳐 이득을 전달합니다."
          },
          "mesosAccuracy": {
            "title": "메소 인식",
            "description": "잘못된 시간당 요율을 줄이기 위해 판독 전반에 걸쳐 재고 가시성과 잔액 변화를 확인하세요."
          },
          "startupSpeed": {
            "title": "시작 로딩",
            "description": "초기 대기 시간과 리소스 사용량을 줄이기 위해 창 선택 후 인식 리소스를 준비합니다."
          },
          "windowSelection": {
            "title": "창 선택",
            "description": "응답성을 향상시키기 위해 브라우저의 창 선택기를 열기 전에 백그라운드 작업을 줄입니다."
          },
          "efficiencyTrend": {
            "title": "효율성 추세 평준화",
            "description": "대시보드에서 효율성 변경 사항을 확인하세요. 새로운 기록의 추세도 로컬 기록에 저장됩니다."
          }
        }
      },
      "launch20260902": {
        "summary": "사용 가능한 첫 번째 릴리스에서는 경험치, 메소 및 기타 레벨업 데이터에 대한 로컬 게임 화면 인식 및 추적이 브라우저에 제공되었습니다."
      }
    }
  },
  "settings": {
    "title": "설정",
    "subtitle": "모양, 인식 및 로컬 재설정을 관리합니다.",
    "language": "표시 언어",
    "languageHint": "즉시 적용되며 이 브라우저에 저장됩니다.",
    "theme": "외관",
    "appearanceHint": "표시 언어, 밝기 모드 및 효율 단위를 설정합니다",
    "themeMode": "라이트·다크 모드",
    "themeHint": "귀하의 환경에 맞는 디스플레이 모드를 선택하세요",
    "light": "라이트 모드",
    "dark": "다크 모드",
    "pipSkin": "위젯 설정",
    "pipSkinDefault": "기본값",
    "pipSkinClassic": "클래식",
    "recognition": "읽기 및 인식",
    "recognitionHint": "각 데이터 소스의 읽기 속도와 인식 동작을 조정합니다.",
    "captureRateUnit": "{count}/초",
    "frequencyDetails": "데이터별 읽기 빈도",
    "recognitionIntervalSeconds": "{count}초마다 1회",
    "recognitionIntervalPerSecond": "{count}회/초",
    "recognitionDisabled": "인식 안 함",
    "recognitionRequired": "필수",
    "recognitionAutomatic": "자동",
    "recognitionDisabledState": "인식 꺼짐",
    "metricFrequencyHint": "경험치, 메소 및 HP/MP는 기본적으로 초당 한 번입니다. 레벨과 맵은 4초마다 실행되고, 작업은 30초마다 실행됩니다. 느린 장치에서는 읽기가 대기열에 포함될 수 있습니다.",
    "metricFrequencyAria": "{metric} 판독 주파수",
    "metricFrequency": {
      "exp": {
        "label": "경험치",
        "hint": "경험치 이득 및 레벨 업"
      },
      "mesos": {
        "label": "메소",
        "hint": "인벤토리가 열려 있어야 합니다."
      },
      "hpMp": {
        "label": "HP / MP",
        "hint": "수치·소모·회복"
      },
      "hp": {
        "label": "HP",
        "hint": "수치·소모·회복"
      },
      "mp": {
        "label": "국회의원",
        "hint": "수치·소모·회복"
      },
      "level": {
        "label": "레벨",
        "hint": "레벨업 및 수정"
      },
      "mapName": {
        "label": "지도",
        "hint": "현재 지도 이름"
      },
      "jobName": {
        "label": "직업",
        "hint": "게임 내 직업"
      }
    },
    "minConfidence": "읽기 엄격함",
    "minConfidenceHint": "값이 높을수록 선택성이 높아지고 품질이 낮은 결과가 거부됩니다.",
    "changeThreshold": "화면 변화 감도",
    "changeThresholdHint": "값이 낮을수록 작은 변화를 감지하고 다른 읽기를 더 빨리 트리거합니다.",
    "restoreRecommendedRecognition": "기본값 복원",
    "recognitionRestored": "기본 인식 설정이 복원되었습니다.",
    "backgroundRecording": "백그라운드 일시 중지 방지",
    "backgroundHint": "Chrome 및 Edge는 메모리 절약을 위해 백그라운드에 남겨진 탭을 일시 중지하여 인식 및 기록을 일시적으로 중지할 수 있습니다. 이러한 중단을 줄이려면 브라우저의 항상 활성 목록에 Maple Log를 추가하세요.",
    "setupPath": "설정 경로",
    "chromePath": "설정 → 성능 → 메모리 절약 → 이 사이트를 항상 활성 상태로 유지",
    "edgePath": "설정 → 시스템 및 성능 → 성능 → 이 사이트를 절전 모드로 전환하지 마세요.",
    "currentDomain": "현재 사이트 도메인",
    "addDomainHint": "최종 설정을 열고 이 도메인을 추가하세요.",
    "copyDomain": "도메인 복사",
    "domainCopied": "복사됨",
    "domainCopyDone": "현재 도메인이 복사되었습니다.",
    "domainCopyFailed": "복사에 실패했습니다. 현재 도메인을 수동으로 추가하세요.",
    "reset": "재설정 및 복원",
    "resetBody": "기본 설정, 보정 및 기록을 처음 사용 상태로 복원합니다.",
    "factoryReset": "초기화",
    "factoryResetTitle": "초기화",
    "factoryResetIntro": "이렇게 하면 이 브라우저에서 선택한 Maple Log 데이터가 제거되고 앱이 다시 로드됩니다.",
    "factoryResetItems": {
      "data": "기록 및 설정",
      "resources": "인식 자원"
    },
    "factoryResetItemHints": {
      "data": "기록, 교정 및 기본 설정",
      "resources": "다음에는 다시 다운로드해야 합니다"
    },
    "factoryResetConfirm": "초기화",
    "factoryResetDisabledRecording": "공장 설정을 복원하기 전에 현재 기록을 완료하세요",
    "factoryResetFailed": "공장 설정을 복원할 수 없습니다. 다시 시도해 보세요.",
    "ocrChecking": "설정 확인 중",
    "ocrDownloading": "화면 인식 준비 중",
    "ocrPrepared": "인식 리소스 준비 완료",
    "ocrInitializing": "인식 엔진 시작 중",
    "ocrReady": "화면 인식 준비 완료",
    "ocrError": "설정 실패"
  },
  "about": {
    "updates": "업데이트",
    "disclaimer": {
      "title": "면책조항",
      "intro": "사용하기 전에 도구의 제한 사항과 책임을 이해하십시오.",
      "accuracyTitle": "통계는 참고용입니다",
      "accuracyBody": "화면 인식은 해상도, 장애물, 게임 업데이트의 영향을 받을 수 있습니다. 경험치, 수익 및 효율성 수치가 정확하지 않을 수 있습니다. 항상 실제 게임 내 데이터를 참조하세요.",
      "usageTitle": "계정 책임",
      "usageBody": "게임과 서버의 약관을 따르세요. 이 도구는 계정의 안전을 보장하지 않습니다. 게임 운영자가 게시한 규칙과 결정이 적용됩니다.",
      "accountNote": "게임 규칙 위반, 기타 제3자 소프트웨어 사용 또는 이 도구와 관련되지 않은 기타 원인으로 인해 발생한 계정 문제, 로그인 제한 또는 차단은 플레이어의 책임이며 이 도구에 귀속되지 않습니다.",
      "rightsTitle": "지적재산권 존중",
      "rightsBody": "게임 이름, 상표 및 자산은 해당 권리 보유자의 소유입니다. 저작권 또는 기타 권리 문제가 있는 경우 위의 피드백 채널을 통해 작성자에게 문의하세요.",
      "note": "해당 법률이 허용하는 한도 내에서 저자는 이 도구의 사용으로 인해 발생하는 부정확한 통계, 데이터 손실 또는 기타 손실에 대해 책임을 지지 않습니다. 본 면책조항은 법적으로 배제될 수 없는 책임을 배제하거나 제한하지 않습니다."
    },
    "title": "Maple Log 소개",
    "subtitle": "Maple Log와 그 제작자에 대해 알아보세요",
    "projectDescription": "Maple Log는 브라우저에서 로컬로 게임 화면을 인식하고 훈련 활동을 유용한 기록으로 전환합니다.",
    "authorLabel": "크리에이터",
    "authorName": "小淳",
    "openAuthorBilibili": "Bilibili에서 {name} 열기",
    "contactLabel": "창작자를 찾아보세요",
    "contactHint": "더 많은 프로젝트와 업데이트를 보려면 이 프로필을 방문하세요.",
    "github": "GitHub",
    "bilibili": "빌리빌리",
    "openExternal": "외부 웹사이트 열기",
    "feedbackTitle": "피드백",
    "feedbackHint": "QQ 그룹에 가입하거나 이메일을 보내 문제를 보고하고 경험을 공유하세요.",
    "qqGroup": "QQ 그룹",
    "copyGroup": "그룹 번호 복사",
    "copyFeedbackGroup": "QQ 그룹 번호 {number} 복사",
    "feedbackCopied": "QQ 그룹번호 복사됨",
    "feedbackCopyFailed": "복사에 실패했습니다. 그룹 번호를 수동으로 복사하세요.",
    "email": "이메일",
    "copyEmail": "이메일 복사",
    "copyFeedbackEmail": "이메일 복사 {email}",
    "emailCopied": "이메일이 복사되었습니다",
    "emailCopyFailed": "복사에 실패했습니다. 이메일을 수동으로 복사하세요.",
    "safetyTitle": "게임에 안전한가요?",
    "safetyIntro": "Maple Log는 브라우저 전용 도구입니다. 클라이언트나 플러그인을 설치하지 않고 게임 파일을 변경하지 않으며 브라우저에서 완전히 인식을 수행합니다.",
    "safetyReport": "안전 보고서 읽기",
    "safetyFairLabel": "게임에 손을 대지 않을 것입니다",
    "safetyLocalLabel": "이 컴퓨터에 유지됩니다.",
    "safetyFrame": "공유 프레임만",
    "safetyFrameHint": "선택한 창이나 화면을 수신하며 게임 플레이 영상은 저장하지 않습니다.",
    "safetyProcess": "게임 프로세스에 액세스할 수 없습니다.",
    "safetyProcessHint": "게임 메모리를 읽거나 게임 코드를 삽입하거나 후크하지 않습니다.",
    "safetyInput": "자동 입력 없음",
    "safetyInputHint": "키보드나 마우스 입력을 시뮬레이션하거나 게임에 명령을 보내지 않습니다.",
    "safetyPromise": "게임 화면은 이 컴퓨터에서 처리되며 업로드되지 않습니다.",
    "safetyReassure": "게임 자격 증명 요청, 게임 수정 또는 자동 플레이가 없습니다.",
    "safetyHow": "브라우저 캡처를 승인하고 창이나 화면을 선택합니다. 이 권한은 게임 메모리나 로그인 자격 증명에 대한 액세스 권한을 부여하지 않습니다. 전체 공유 화면에는 눈에 보이는 민감한 콘텐츠가 포함되어 있습니다.",
    "safetyStepSandbox": "브라우저가 이를 차단합니다.",
    "safetyStepSandboxHint": "디스플레이 캡처는 게임 메모리나 로그인 자격 증명에 대한 액세스 권한을 부여하지 않습니다.",
    "safetyStepChoose": "당신은 창문을 선택",
    "safetyStepChooseHint": "당신은 표면을 선택합니다. 전체 공유 화면에는 표시되는 창이 포함됩니다.",
    "safetyStepLocal": "이 컴퓨터에서 읽기",
    "safetyStepLocalHint": "해당 창을 그림으로 처리하고 여기에 있는 숫자를 읽습니다. 사진은 온라인으로 전송되지 않습니다.",
    "privacyTitle": "개인정보 보호",
    "privacyPromise": "플레이어 정보를 일절 수집하지 않으며, 데이터는 전체 처리 과정에서 익명으로 유지됩니다.",
    "privacyIdentity": "신원 정보 수집 없음",
    "privacyIdentityHint": "게임 계정, 비밀번호, 캐릭터명을 요구하지 않으며, 플레이어의 신원을 식별할 수 있는 정보를 수집하거나 업로드하지 않습니다.",
    "privacyLocal": "원본 화면은 기기에서 처리",
    "privacyLocalHint": "게임 화면, 스크린샷, OCR 원문은 브라우저 안에서만 처리합니다. 인식 영역과 보정 설정도 기기에만 저장합니다.",
    "privacyRank": "익명 순위 통계",
    "privacyRankHint": "조건을 충족한 익명 통계 요약만 자동 제출합니다. 무작위 식별자는 중복 제거에 사용하며 게임 계정과 연결하지 않습니다.",
    "privacyReport": "개인정보 보호 상세 설명 보기"
  }
}
